{
  "adgroup": {
    "alwaysFirst": "Toujours premier",
    "archiveWarning": "Vous êtes sur le point d'archiver définitivement cet AdGroup. Aucune donnée ne sera perdue, mais vous ne pourrez plus l'activer à nouveau. Voulez-vous archiver définitivement cet AdGroup ?",
    "created": "Nouvel AdGroup créé !",
    "updated": "Votre AdGroup a été modifié !",
    "goToAdgroup": "Aller à {{adgroupName}}",
    "sectionTitle": "Résumé de l'AdGroup",
    "appendClickId": "Ajouter l'ID de clic",
    "type": "Type",
    "format": "Format",
    "redirectUrl": "URL de redirection",
    "redirectUrlDoubleClickWarning": "Il est impossible de transmettre l'ID de clic sur un lien DoubleClick sans ajouter le lien de destination à la fin.",
    "rulesExceptionsLabel": "Règles d'exclusion géographique",
    "rulesExceptions": "Vous pouvez bloquer les pays avec lesquels vous ne voulez pas traiter. Le trafic provenant de ces pays sera redirigé vers l'URL de redirection suivante au lieu de celle par défaut.",
    "redirectUrlHelper": "Elle doit inclure des paramètres de suivi. Si aucune URL n'est spécifiée dans la créative, cette URL sera utilisée.",
    "channels": "Canaux",
    "redirectUrlUtmGenerator": {
      "title": "Assistant pour l'URL de redirection",
      "generateUrl": "Générer l'URL",
      "generatedUrl": "URL générée",
      "utmDetectedMessage": "Clés UTM existantes détectées dans l'URL courante : {{keys}}. La génération mettra à jour ces clés.",
      "utmParameters": "Paramètres UTM",
      "valueType": "Type",
      "customValue": "Fixe",
      "dynamicValue": "Dynamique",
      "parameterValue": "Valeur",
      "noUtmFound": "Aucun paramètre UTM trouvé dans l'URL de redirection.",
      "initializeDefaultUtm": "Ajouter les UTM par défaut",
      "resetDefaultUtm": "Réinitialiser les UTM par défaut",
      "customParameters": "Paramètres personnalisés",
      "addParameter": "Ajouter un paramètre",
      "noCustomParameters": "Aucun paramètre personnalisé.",
      "documentation": "Documentation",
      "defaultUtmValues": "Valeurs UTM par défaut",
      "applyToRedirectUrl": "Appliquer à l'URL de redirection",
      "serverTokens": {
        "title": "Tokens de remplacement serveur",
        "groups": {
          "advertiserInfo": "Informations annonceur",
          "publisherInfo": "Informations éditeur"
        },
        "clickIdAutoNote": "Note : {clickId} est ajouté automatiquement s'il est manquant.",
        "descriptions": {
          "campaignId": "Identifiant de la campagne",
          "campaignName": "Nom de la campagne",
          "adGroupId": "Identifiant de l'ad group",
          "adGroupName": "Nom de l'ad group",
          "adcopyInfos": "Informations créative",
          "adCopyId": "Identifiant de la créative",
          "adCopyName": "Nom de la créative",
          "clickId": "Identifiant de clic unique (ajouté automatiquement si manquant)",
          "publisherInfos": "Informations éditeur",
          "pubName": "Nom de l'éditeur",
          "siteName": "Nom du site",
          "posName": "Nom de la position"
        }
      }
    },
    "channelsHelper": "Les canaux regroupent les positions d'annonces par type de canal. 'Email' correspond aux annonces natives dans les newsletters/e-mails, tandis que 'Web' correspond aux annonces natives sur les sites web.",
    "network": "Réseau",
    "notFound": "AdGroup introuvable",
    "create": "Créer un AdGroup",
    "edit": {
      "sectionTitle": "Modifier l'AdGroup"
    },
    "details": {
      "archived": "Archivé",
      "budgetCapping": "Capping",
      "companyName": "Entreprise",
      "costType": "Type",
      "costValueWithCurrency": "Coût",
      "dailyBudgetWithCurrency": "Budget journalier",
      "marketCode": "Marché",
      "network": "Réseau",
      "title": "Détails",
      "resellerName": "Revendeur",
      "impressionPixels": "Pixels d'impression",
      "clickPixels": "Pixels de clic",
      "commission": "Commission",
      "campaignId": "Sélectionnez la campagne du nouvel AdGroup",
      "type": "Type"
    },
    "budgetAndDates": {
      "title": "Budgets et dates",
      "dailyBudgetTypeHelper": "- Fixe: Le budget journalier est fixe.<br />- Ouvert: Le budget journalier n'a pas de limite.<br />- Automatique: Le budget journalier est automatiquement calculé en fonction du plafonnement budgétaire et de la date de fin.",
      "dailyBudgetHelper": "C'est le budget maximum de l'Adgroup par jour. Il peut être ajusté plus tard",
      "budgetCapping": "Plafonnement budgétaire",
      "budgetCappingHelper": "Cette configuration optionnelle limitera le budget mensuel ou total de l'AdGroup. L'AdGroup s'arrêtera lorsque le budget sera atteint.",
      "budgetCappingType": "Type de plafonnement budgétaire",
      "budgetCappingTypeHelper": "- Mensuel : le budget est réinitialisé au début de chaque mois.<br />- Sans limite : le budget est illimité.<br />- Global : le budget est une limite sur toute la durée de vie de l'AdGroup.<br />- Période : le budget s'applique de la date de début jusqu'à la fin de l'AdGroup.",
      "budgetCappingPeriod": "Période",
      "budgetTypeLabel": "Type de budget journalier",
      "budgetType": {
        "Fixed": "Fixe",
        "Open": "Sans limite",
        "Auto": "Automatique"
      },
      "endDateValidation": "La date de fin ne peut pas être avant la date de début",
      "dateHelper": "Cette configuration optionnelle vous permet de définir des dates personnalisées pour votre AdGroup. Les dates sont incluses. L'AdGroup commencera à 00h01 et s'arrêtera à 23h59.",
      "overallCalculator": {
        "title": "Calculateur de budget overall",
        "open": "Ajuster le budget overall",
        "currentBudget": "Budget actuel",
        "leftToSpend": "Reste à dépenser",
        "amount": "Montant à ajouter ou retirer",
        "amountHelper": "Saisissez un montant positif pour augmenter le budget, ou un montant négatif pour le diminuer.",
        "preview": "Aperçu",
        "newBudget": "Nouveau budget",
        "newLeftToSpend": "Nouveau reste à dépenser",
        "apply": "Appliquer au budget",
        "outOfBounds": "Le nouveau budget doit être compris entre {{min}} et {{max}}."
      },
      "budgetPlans": {
        "button": "Planifier des changements",
        "title": "Changements de budget planifiés",
        "add": "Ajouter un changement planifié",
        "edit": "Modifier le changement planifié",
        "editTitle": "Modifier le changement planifié",
        "plannedDate": "Date d'exécution",
        "dateHelper": "Le changement est appliqué par le traitement quotidien à partir de cette date. Seules les dates à partir de demain peuvent être planifiées.",
        "unchanged": "Aucun changement",
        "empty": "Aucun changement de budget planifié",
        "delete": "Supprimer le changement planifié",
        "dateMustBeFuture": "Choisissez une date à partir de demain",
        "duplicateDate": "Un plan existe déjà pour cette date",
        "atLeastOneChange": "Définissez au moins un champ coût, budget ou période à modifier",
        "autoOpenForbidden": "Le budget journalier automatique ne peut pas être combiné avec un plafonnement ouvert",
        "previewCost": "Coût",
        "previewPeriod": "Période"
      }
    },
    "status": {
      "ended": "Terminé",
      "nobudgetleft": "Aucun budget restant",
      "startsoon": "Commencera bientôt",
      "archived": "Archivé",
      "activationWarning": {
        "nobudgetleft": "Sera automatiquement réactivé après l'augmentation du budget",
        "startsoon": "Sera automatiquement activé à la date de début",
        "ended": "Sera automatiquement réactivé après la modification ou la suppression de la date de fin",
        "archived": "Impossible d'activer un AdGroup archivé"
      }
    },
    "spentBudget": {
      "daySpent": "dépensé aujourd'hui",
      "monthSpent": "dépensé par mois",
      "overallSpent": "dépensé au global",
      "periodSpent": "dépensé depuis le début de la periode",
      "leftAmount": "({{left}} restants)",
      "history": {
        "open": "Voir l'historique du budget",
        "title": "Historique du budget",
        "seriesToggleLabel": "Séries du graphique",
        "costChartTitle": "Valeur du coût par jour ({{costType}})",
        "noCostChartData": "Aucun changement de coût sur cette période.",
        "noChanges": "Aucun changement de date sur cette période.",
        "chartLegendCost": "{{label}} : {{value}} ({{costType}})",
        "chartLegendValue": "{{label}} : {{value}}",
        "chartLegendCapping": "{{label}} : {{value}} ({{type}})",
        "chartLegendTypeOnly": "{{label}} : {{type}}",
        "changedBy": "Modifié par {{name}}"
      },
      "messageStatus": {
        "endDatePassed": "| a été arrêté le {{endDate}}",
        "overSpent": "| plus de budget depuis le {{stoppedDate}}",
        "willStart": "| commencera le {{startDate}}",
        "willStopAtMonthly": "| s'arrêtera le {{endDate}} & {{leftMonthBudget}} restant pour le mois",
        "willStopAtPeriod": "| s'arrêtera le {{endDate}} & {{leftPeriodBudget}} restant",
        "willStopAtOverall": "| s'arrêtera le {{endDate}} & {{leftOverallBudget}} restant",
        "willStop": "| s'arrêtera le {{endDate}}",
        "budgetMonthly": "| {{leftMonthBudget}} restant pour le mois",
        "budgetPeriod": "| {{leftPeriodBudget}} restant",
        "budgetOverall": "| {{leftOverallBudget}} restant"
      },
      "warning": {
        "endDateSoon": "Cet adGroup s'arrêtera dans {{daysThreshold}} jours ou moins."
      }
    },
    "userCapping": {
      "title": "Capping utilisateur",
      "event": "événement",
      "period": "Période",
      "value": "valeur",
      "noCapping": "Pas de limite",
      "helperText": "Impressions = nombre de fois où une personne peut voir votre pub. Clicks = nombre de fois où une personne peut cliquer sur votre pub."
    },
    "userTargeting": {
      "autoSegments": {
        "noSegment": "Aucun auto segment actif",
        "title": "Segments Automatiques",
        "add": "Ajouter un segment automatique",
        "type": "Type",
        "dimension": "Dimension",
        "delete": "Supprimer ce segment automatique",
        "id": "Nom",
        "duration": "Durée (jour)",
        "isExcluded": "Inclu/Exclu",
        "dimensions": {
          "Advertiser": "Annonceur",
          "Publisher": "Éditeur",
          "AdGroup": "AdGroup",
          "Website": "Site Web",
          "Campaign": "Campagne",
          "AdGroupIab": "AdGroup Iab",
          "PositionIab": "Position Iab"
        }
      },
      "tags": {
        "noTags": "Aucun tag actif",
        "title": "Tags",
        "add": "Ajouter un tag",
        "delete": "Supprimer ce tag",
        "origin": "Origine",
        "profileCount": "Nombre de profils",
        "description": "Description",
        "isExcluded": "Inclu/Exclu"
      },
      "customAudienceLabel": "Audience personnalisée",
      "targetingGenderLabel": "Ciblage par genre",
      "targetingAgeLabel": "Ciblage par âge",
      "gender": {
        "Male": "Homme",
        "Female": "Femme"
      },
      "targeting": "Ciblage",
      "customAudience": {
        "cdate": "Date de création",
        "nbProfiles": "Nombre de profils"
      },
      "noActiveSegments": "Vous n'avez aucun segment actif. ",
      "goToCampgaignSegments": "Allez aux ségments de la campagne.",
      "title": "User Targeting"
    },
    "deviceTypes": {
      "title": "Types d'appareils",
      "helperText": "Permet de cibler des utilisateurs spécifiques *naviguant* à partir de dispositifs et d'OS spécifiques",
      "deviceTargetingLabel": "Ciblage par appareils",
      "osTargetingLabel": "Ciblage par Os",
      "deviceType": {
        "Desktop": "Ordinateur",
        "Mobile": "Mobile",
        "Tablet": "Tablette"
      },
      "osType": {
        "Android": "Android",
        "Ios": "iOS",
        "Macos": "macOS",
        "Windows": "Windows"
      }
    },
    "geoTargeting": {
      "title": "GeoTargeting",
      "helperText": "Par défaut, les annonces sont diffusées sur l'inventaire du marché de l'Adgroup. Les utilisateurs naviguant depuis d'autres pays peuvent également être ciblés.",
      "rule": "Règle",
      "locationType": "Type de lieu",
      "locationTypeHelper": "Vous ne pouvez sélectionner qu'un seul type. Si vous changez votre sélection, elle sera effacée.",
      "cities": "Villes",
      "departements": "Départements",
      "regions": "Régions",
      "countries": "Pays",
      "location": "Lieu(x)",
      "viewAllLocations_one": "Voir tous les lieux ({{count}})",
      "viewAllLocations_other": "Voir tous les lieux ({{count}})",
      "manageLocationsTitle": "Gérer les lieux ({{count}})",
      "viewLocationsTitle": "Tous les lieux ({{count}})",
      "radiusDialogTitle": "Modifier le rayon autour de {{city}}",
      "marketCountry": "Vos publicités seront affichées sur le marché {{countryCode}}",
      "acceptedCountries": "Pays acceptés",
      "importCSV": "Importation par CSV",
      "targetingAddresses": {
        "clearPrevious": "Effacer l'ancien GeoTargeting",
        "numberAddressesFound": "{{addressesFound}} addresses trouvées",
        "radius": "Rayon",
        "csvUploadInfoMessage": "Téléchargez un fichier CSV contenant une liste de noms de villes et/ou de codes postaux. Chaque entrée doit être placée sur une nouvelle ligne. Vous pouvez avoir un mélange de noms de villes et de codes postaux.",
        "success": "La liste des villes et des codes postaux a été importée.",
        "unrecognizedCitiesMessage": "Certaines villes du fichier CSV téléchargé n'ont pas pu être trouvées. Veuillez vérifier la liste des villes non reconnues ci-dessous, corriger les erreurs ou les fautes de frappe, et essayez de télécharger le fichier à nouveau :"
      },
      "viewAllLocations_many": "Voir tous les lieux ({{count}})"
    },
    "timeOfTheDay": {
      "title": "Moments de la journée",
      "helperText": "Permet de diffuser des annonces sur les jours et périodes sélectionnés.",
      "daysOfTheWeekLabel": "Jours de la semaine",
      "hoursOfTheDayLabel": "Heures de la journée",
      "days": {
        "Monday": "Lundi",
        "Tuesday": "Mardi",
        "Wednesday": "Mercredi",
        "Thursday": "Jeudi",
        "Friday": "Vendredi",
        "Saturday": "Samedi",
        "Sunday": "Dimanche"
      }
    },
    "tabs": {
      "dashboard": "tableau de bord",
      "settings": "paramètres",
      "directory": "restriction de diffusion",
      "bidAdjustments": "ajustements des enchères",
      "adPreview": "aperçu",
      "blacklist": "Liste noire"
    },
    "assistant": {
      "title": "AdGroup Assistant",
      "button": "Assistant",
      "showMeLater": "Me le rappeler plus tard",
      "okForToday": "OK pour aujourd'hui",
      "recommendationsTitle": "Recommandations adgroup",
      "noRecommendations": "Aucune recommandation disponible pour le moment.",
      "noDataYet": "pas de données pour le moment",
      "hideRule": "Masquer la règle",
      "showRule": "Afficher la règle",
      "disableRule": "Désactiver la règle",
      "enableRule": "Activer la règle",
      "hidden": "Masquée",
      "showHiddenRules": "Afficher les règles masquées",
      "hideHiddenRules": "Masquer les règles masquées",
      "ruleHidden": "Règle masquée avec succès",
      "ruleHideFailed": "Échec du masquage de la règle",
      "ruleShown": "Règle affichée avec succès",
      "ruleShowFailed": "Échec de l'affichage de la règle",
      "ruleDisabled": "Règle désactivée avec succès",
      "ruleDisableFailed": "Échec de la désactivation de la règle",
      "ruleEnabled": "Règle activée avec succès",
      "ruleEnableFailed": "Échec de l'activation de la règle",
      "decisions": {
        "abTest": "A/B test",
        "continue": "Continuer",
        "stop": "Arrêter"
      },
      "recommendations": {
        "abTest": "Lancer cette créative en mode test A/B.",
        "continue": "Conserver cette créative active.",
        "stop": "Mettre cette créative en pause."
      },
      "recommendationCodes": {
        "AdCopyMaxLifetimeExceeded": "Une ou plusieurs créatives ont atteint la durée maximale de vie",
        "AdGroupNotEnoughAdCopiesForBudget": "L'adgroup n'a pas assez de créatives pour le budget",
        "AdGroupTooManyAdCopiesForBudget": "L'adgroup a trop de créatives pour le budget",
        "AdGroupAdCopyReadyForNewAbTest": "L'adgroup a une créative prête pour un nouveau A/B test",
        "AdGroupImbalancedAbTestImpressions": "L'adgroup a un nombre d'impressions A/B test non équilibré",
        "AdGroupIncreaseDailyBudgetForBudgetCapping": "L'adgroup a un plafonnement budgétaire journalier trop bas. Augmenter le budget journalier ou utiliser un budget journalier automatique"
      },
      "table": {
        "adCopy": "Créative",
        "decision": "Décision",
        "recommendation": "Recommandation",
        "actions": "Actions",
        "startedAt": "Date de début",
        "hiddenColumnsWarning": "Les colonnes suivantes sont masquées car elles n'ont pas de données : {{columns}}",
        "lr": "LR",
        "cpl": "CPL",
        "or": "OR",
        "cpo": "CPO",
        "roi": "ROI"
      },
      "importance": {
        "high": "Haute",
        "medium": "Moyenne",
        "low": "Faible"
      },
      "stepRecommendations": "Recommandations"
    },
    "bidAdjustments": {
      "title": "Ajustements des enchères",
      "byDeviceType": {
        "title": "Par type d'appareil",
        "table": {
          "deviceType": "Type d'appareil",
          "adjustment": "Ajustement",
          "adjustedDefaultCost": "Coût",
          "wantedAdjustment": "Ajustement souhaité"
        }
      },
      "byWebsite": {
        "confirmRemoveWebsite": "Êtes-vous sûr de vouloir supprimer les ajustements du site web {{name}} ?",
        "title": "Par sites web",
        "table": {
          "website": "Site web",
          "url": "Url",
          "adjustment": "Ajustement",
          "wantedAdjustment": "Ajustement souhaité",
          "calculateAdjustedDefaultCost": "Coût"
        },
        "searchInDirectory": {
          "title": "Sites web des éditeurs",
          "addWebsites": "Ajouter des ajustements"
        }
      },
      "costLimit": {
        "min": "Le nouveau coût calculé est en dessous du coût minimum de {{minCostByType}}. L'ajustement enregistré sera de {{realAdjustment}}%.",
        "max": "Le nouveau coût calculé est au-dessus du coût maximum de {{maxCostByType}}. L'ajustement enregistré sera de {{realAdjustment}}%."
      },
      "costValueOutsideLimits": "Le coût de cet adGroup est en dehors des limites autorisées. Veuillez ajuster le coût dans les réglages pour qu'il soit compris entre les valeurs minimale et maximale."
    },
    "blacklistPage": {
      "description": "Liste de tous les sites web où cet adgroup ne peut pas être affiché car le publisher l'a mis sur liste noire.",
      "trafficLost": "{{blacklistPercent}}% de trafic perdu, {{finalPercent}}% de trafic restant",
      "website": "Site web",
      "publisher": "Éditeur",
      "reseller": "Revendeur",
      "reasons": "Raisons"
    },
    "directory": {
      "title": "Preset de restriction",
      "updated": "La liste des restrictions de diffusion a été mise à jour!",
      "cannotUpdateType": "Vous pouvez mettre à jour le type de restriction uniquement s'il n'y a pas encore de restriction",
      "addPosition": "Ajouter des positions",
      "presets": "Presets de restriction de diffusion",
      "presetInventory": "Presets de restriction de diffusion",
      "selectPresets": "Utiliser un preset",
      "selectPresetsTitle": "Sélectionner des presets de restriction de diffusion",
      "convertToPreset": "Convertir en preset",
      "convertToPresetTitle": "Convertir la liste de restriction en preset",
      "parentCompany": "Société parente",
      "replaceWithPresetConfirm": "Remplacer la liste de restriction actuelle par le preset {{name}} ?",
      "replaceWithPresetApplied": "Preset appliqué et liste de restriction effacée",
      "managePresets": "Gérer les presets de restriction de diffusion",
      "presetPreview": "{{websiteCount}} sites, {{positionCount}} positions",
      "searchDirectory": {
        "title": "Sites web des publishers",
        "saved": "Sites Web ajoutés avec succès à la restriction de diffusion",
        "positions": "Positions",
        "presets": "Presets de restriction de diffusion",
        "presetsSaved": "Presets de restriction de diffusion mis à jour",
        "noPresets": "Aucun preset de restriction de diffusion disponible"
      },
      "directoryList": {
        "reseller": "Revendeur",
        "impressions": "Trafic"
      },
      "incompatibleCreativesPosition": "Aucun creative actif ne peut être diffusé sur cette position.",
      "incompatibleCreativesWebsite": "Certaines positions de ce site web ne sont pas compatibles avec les creatives actifs.",
      "templateSizes": "Tailles des templates : {{sizes}}",
      "alert": {
        "veryLow": "Cette liste de restrictions inclut seulement {{ percent }}% des impressions disponibles, vous devriez envisager d'inclure davantage de sites web.",
        "low": "Cette liste de restrictions inclut seulement {{ percent }}% des impressions disponibles.",
        "default": "Cette liste de restrictions inclut {{ percent }}% des impressions disponibles."
      }
    },
    "adPreview": {
      "label": "Sites et positions",
      "info": "Selectionnez une position pour afficher la aperçu",
      "channelTypeWarning": "Aucun cannal de diffusion configuré",
      "noPositions": "Impossible d'afficher une aperçu, aucune position n'est disponible",
      "noActiveAdCopy": "Aucune créative active sur ce groupe d'annonces.",
      "goToAdCopies": "Aller à la page des créatives.",
      "positionNotInDirectory": "La position sélectionnée n'est pas compatible avec cet adGroup.",
      "adServerPreview": "Aperçu via AdServer",
      "preview": "Aperçu des créatives",
      "incompatibleAdCopies": "Créatives incompatibles",
      "noCompatibleAdCopies": "Aucune créative compatible",
      "minRequiredWidth": "Largeur minimale requise",
      "minRequiredHeight": "Hauteur minimale requise",
      "tooSmallBy": "{{label}} est trop petite de {{value}}px"
    },
    "duplicateStatusWarning": "La copie sera désactivée. Vous devrez l'activer manuellement.",
    "analytics": {
      "import": "Ajouter des stats depuis analytics",
      "processingImport": "Traitement de l'import…",
      "rowsDetected": "{{rows}} lignes",
      "description": "Téléchargez un fichier CSV contenant des données d'analytics. Chaque entrée doit être placée sur une nouvelle ligne.",
      "dropCsvFile": "Déposez votre fichier CSV ici",
      "dropCsvFileOr": "ou",
      "success": "Importé avec succès",
      "at": "Date",
      "adCopyId": "Creative",
      "pageViews": "Page vue",
      "sessions": "Sessions",
      "engagedSessions": "Sessions engagées",
      "totalUsers": "Utilisateurs",
      "newUsers": "Nouveau utilisateurs",
      "bounceRate": "Taux rebond",
      "engagementRate": "Taux engement",
      "sessionTimeSeconds": "Temps de session",
      "cpv": "CPV",
      "viewOriginalFile": "Voir le fichier original",
      "originalFileTitle": "Fichier original : {{filename}}",
      "mapCreativesTooltip": "Associez chaque nom de creative importé à une creative de cet ad group",
      "mapCreativesTitle": "Associer les creatives",
      "mapCreativesDescription": "Indiquez quelle creative de l'ad group correspond à chaque nom présent dans votre fichier.",
      "mapCreativesDecodeImportedNames": "Décoder les URL et remplacer + par des espaces",
      "mapCreativesFilter": "Filtrer les noms importés",
      "mapCreativesFilterHelper": "Laissez vide pour inclure tous les noms, ou choisissez Ad*.",
      "mapCreativesFilterEmpty": "Aucun nom de creative importé ne correspond à ce filtre.",
      "mapCreativesImportedName": "Nom importé",
      "mapCreativesMatchDoubleClickPlacementId": "Associer avec le placementID DoubleClick",
      "mapCreativesMatchUtmContent": "Associer avec utm_content de l'URL de redirection",
      "mapCreativesMappedCount": "Associées {{mapped}} / {{total}}",
      "mapCreativesRemoveStatusText": "Retirer le texte de statut",
      "mapCreativesSelectedCreative": "Creative de l'ad group",
      "mapCreativesSettings": "Paramètres d'association",
      "mapCreativesEmpty": "Aucun nom de creative trouvé dans les données importées.",
      "showAllValues": "Tout afficher",
      "atLeastOneCreativeMustBeImportable": "Associez au moins une creative importée avec une date valide avant d'importer.",
      "missingStartDateWarning": "Les creatives suivantes n'ont pas de date de début et n'ont pas été réparties sur la période : {{adCopies}}.",
      "sourceColumn": "Colonne",
      "sourceColumns": "Colonnes",
      "mappingMode": "Mode d'association",
      "calculation": "Calcul",
      "formulaHelp": "Pour les colonnes de stats, choisissez une ou plusieurs colonnes du fichier ou créez un calcul avec les colonnes.",
      "formulaInsertColumn": "Insérer une colonne",
      "formulaExpression": "Calcul",
      "formulaPlaceholder": "Créez un calcul à partir des colonnes du fichier",
      "formulaBuilderHelp": "Cliquez sur les colonnes ci-dessus pour les insérer, puis modifiez le calcul si nécessaire.",
      "formulaClear": "Effacer le calcul",
      "formulaCreate": "Créer un calcul",
      "formulaEdit": "Modifier le calcul",
      "formulaModalHint": "Ouvrez l'éditeur pour choisir des colonnes et prévisualiser les résultats.",
      "formulaTooltipHint": "Survolez pour voir le calcul actuel.",
      "formulaBuilderTitle": "Calcul pour {{field}}",
      "formulaModalDescription": "Créez le calcul en insérant les colonnes du fichier importé. Les exemples ci-dessous utilisent les premières lignes du fichier.",
      "formulaPreviewTitle": "Exemples de résultats",
      "formulaRow": "Ligne",
      "formulaSampleValues": "Valeurs d'exemple",
      "formulaResult": "Résultat",
      "formulaError": {
        "emptyExpression": "le calcul est vide",
        "unknownHeader": "colonne inconnue",
        "ambiguousHeader": "nom de colonne ambigu",
        "invalidSyntax": "calcul invalide",
        "divisionByZero": "division par zéro"
      },
      "allCreativesMustBeMapped_one": "Associez chaque creative importée à une creative de cet ad group avant d'importer. 1 creative non associée sera ignorée.",
      "allCreativesMustBeMapped_other": "Associez chaque creative importée à une creative de cet ad group avant d'importer. {{count}} creatives non associées seront ignorées.",
      "showMappedValues_one": "Non associées (1)",
      "showMappedValues_other": "Non associées ({{count}})",
      "mapCreatives_one": "Associer les creatives (1)",
      "mapCreatives_other": "Associer les creatives ({{count}})",
      "formulaErrors_one": "1 erreur de calcul : {{errors}}",
      "formulaErrors_other": "{{count}} erreurs de calcul : {{errors}}",
      "allCreativesMustBeMapped_many": "Associez chaque creative importée à une creative de cet ad group avant d'importer. {{count}} creatives non associées seront ignorées.",
      "showMappedValues_many": "Non associées ({{count}})",
      "mapCreatives_many": "Associer les creatives ({{count}})",
      "formulaErrors_many": "{{count}} erreurs de calcul : {{errors}}"
    },
    "reach": {
      "veryLow": "Cet adGroup inclut seulement {{ percent }}% des impressions disponibles, vous devriez envisager d'inclure davantage de sites web.",
      "low": "Cet adGroup inclut seulement {{ percent }}% des impressions disponibles.",
      "default": "Cet adGroup inclut {{ percent }}% des impressions disponibles.",
      "info": "Cette information n'inclut pas le ciblage géographique ni les segments.",
      "recommendedCpc": "CPC recommandé :"
    },
    "debug": {
      "title": "AdGroup Debug"
    }
  },
  "campaign": {
    "sectionTitle": "Résumé de la campagne",
    "advertiserDomainName": "Domaine de l'annonceur",
    "name": "Nom de la campagne",
    "adGroupTaxonomy": {
      "title": "Groupes d'annonces et leur taxonomie",
      "view": "Vérifier la taxonomie des AdGroups",
      "taxonomy": "Taxonomie"
    },
    "create": "Créer une nouvelle campagne",
    "created": "La campagne a été créée avec succès !",
    "details": {
      "adGroups": "AdGroups",
      "advertiserDomainName": "Domaine de l'annonceur",
      "companyName": "Entreprise",
      "marketCode": "Marché",
      "resellerName": "Revendeur",
      "domainName": "Domaine",
      "type": "Type",
      "stepperTitle": "Détails de la campagne",
      "iabCategory": "Catégorie IAB"
    },
    "analytics": {
      "sessions": "Sessions",
      "session": "Session",
      "landing": "Landing",
      "lead": "Lead",
      "leadId": "ID du lead",
      "orderId": "ID de commande",
      "order": "Commande",
      "iframe": "Iframe",
      "image": "Image",
      "tracking": {
        "title": "Tag Javascript",
        "tagVersions": "Versions du Tag",
        "confirmationTags": "Tags de confirmation",
        "sessionTags": "Tags de session",
        "confirmationWarning": "Un Tag de Session ou de Landing doit déjà avoir été posé au préalable sur la page de redirection de votre publicité pour pouvoir poser un Tag de confirmation.",
        "mainWarning": "Veuillez utiliser un seul de nos Tags par page.",
        "additionalLeadWarning": "N'oubliez pas d'ajouter la valeur de votre ID de lead interne dans le {lead-id}.",
        "additionalOrderWarning": "N'oubliez pas d'ajouter la valeur de votre ID de commande interne dans le {order-id}, la valeur de votre commande dans le {order-value}, ainsi que la devise si ce n'est pas EUR.",
        "lead": "Code de suivi à ajouter sur votre page de confirmation Lead.",
        "order": "Code de suivi à ajouter sur votre page de confirmation de commande.",
        "replaceUnique": "doit être remplacé par un",
        "replace": "doit être remplacé par le",
        "orderAmount": "montant de la commande",
        "orderAmountSeparator": "avec un \".\" comme séparateur décimal.",
        "orderCurrency": "devise de la commande",
        "orderCurrencyExample": "\"EUR\" pour euros (€), \"USD\" pour dollars américains ($).",
        "cookiesUsed": "Pour fonctionner correctement, ce tag utilise les cookies suivants. Ils stockent des informations techniques anonymes qui nous permettent de mesurer les sessions et les conversions avec précision. Il est impossible de suivre les leads ou les commandes sans ces cookies.",
        "cookieName": "Nom du cookie",
        "cookiePurpose": "Objectif",
        "cookieRetention": "Rétention",
        "sendPageViews": "Envoyer les pages vues",
        "cookies": {
          "pwqci": {
            "purpose": "ID de clic - stocke l'identifiant de clic depuis l'URL de redirection pour détecter le lead ou la commande",
            "retention": "30 jours"
          },
          "pstuid": {
            "purpose": "Powerspace Tracking User ID - identifiant unique de l'utilisateur",
            "retention": "30 minutes"
          },
          "pwpv": {
            "purpose": "Page View - stocke l'URL analytics chiffrée avec les données de session/page vue",
            "retention": "30 minutes"
          }
        }
      },
      "serverTracking": {
        "title": "Server to Server",
        "mainWarning": "Veuillez fournir des informations supplémentaires.",
        "fullWarning": "Vous devez remplacer le {clickId} par la valeur trouvée dans votre url après la redirection de Powerspace.",
        "parameters": {
          "clickId": {
            "description": "L'identifiant de clic provenant de l'URL de redirection pour détecter le lead ou la commande. Vous devez remplacer le {clickId} par la valeur trouvée dans votre URL après la redirection depuis Powerspace."
          },
          "orderValue": {
            "description": "Le montant de la commande avec \".\" comme séparateur décimal."
          }
        },
        "headers": {
          "parameter": "Paramètre",
          "description": "Description",
          "required": "Obligatoire"
        }
      },
      "standardTracking": {
        "title": "Tags de suivi standard (dépréciés)"
      },
      "attributionSettings": {
        "title": "Paramètres d'attribution",
        "subtitle": "Paramètres d'attribution post-clic",
        "confirmDialogTitle": "Êtes-vous sûr ?",
        "confirmDialogMessage": "Changer ce paramètre affectera le suivi et moins de conversions apparaîtront dans les rapports"
      }
    },
    "edit": {
      "sectionTitle": "Modifier la campagne"
    },
    "goToCampaign": "Aller à {{campaignName}}",
    "adgroupsHelper": "Ajoutez éventuellement des groupes d'annonces à la nouvelle campagne. Vous pouvez en ajouter plusieurs avant de terminer la création.",
    "copperOpportunity": "Opportunité Copper",
    "copperOpportunityStage": "Étape d'opportunité Copper",
    "copperOpportunityBudgetRemaining": "{{amount}} du budget de l'opportunité sélectionnée ne sont pas encore affectés aux groupes d'annonces.",
    "spentBudget": {
      "messageStatus": {
        "leftBeforeDate": "| {{leftBudget}} restant avant le {{endDate}}",
        "leftThisMonth": "| {{leftBudget}} restant ce mois-ci",
        "left": "| {{leftBudget}} restant"
      },
      "tooltip": {
        "monthly": "{{name}} — {{leftBudget}} restant ce mois-ci",
        "period": "{{name}} — {{leftBudget}} restant sur la période",
        "overall": "{{name}} — {{leftBudget}} restant au global",
        "open": "{{name}} — sans limite"
      },
      "warning": {
        "endDateSoon": "Cette campagne s'arrêtera dans {{daysThreshold}} jours ou moins.",
        "endOfMonthSoon": "Le budget mensuel sera réinitialisé dans {{daysThreshold}} jours ou moins."
      }
    },
    "segments": {
      "Created": "Créé",
      "createdSuccess": "Le segment a été créé avec succès !",
      "Processed": "Terminé",
      "Processing": "En cours",
      "Deleting": "Suppression",
      "Error": "En erreur",
      "updatedSuccess": "Segment mis à jour !",
      "Profiles": "profils",
      "reachInfo": "Portée: {{reach}}%",
      "errors": {
        "UnsufficientValidLines": "pas assez de lignes valides"
      },
      "nbProfilesInfo": "Ce segment contient {{nbProfiles}} profils.",
      "email": {
        "title": "Segments e-mail",
        "lastModified": "Dernière date de modification",
        "originalFilename": "Nom du fichier original",
        "uploadFile": "Télécharger un nouveau fichier",
        "formatInfo": "Les e-mails doivent être écrits en minuscules avant le téléchargement.",
        "sampleFile": "Vous pouvez télécharger un fichier exemple",
        "fileType": "Les formats .csv ou .txt sont acceptés. Minimum 50 lignes avec 1 e-mail par ligne.",
        "modal": {
          "title": "Gérer le segment",
          "deleteTitle": "Confirmation de suppression du segment Email",
          "delete": "Vous êtes sur le point de supprimer le segment {{segmentName}}. \nÊtes-vous sûr de vouloir continuer ?"
        }
      },
      "behavioural": {
        "title": "Segments comportementaux",
        "newSegment": "Créer un nouveau segment",
        "lastModified": "Dernière date de modification",
        "manage": "Mettre à jour les comportements",
        "duration": "Durée",
        "modal": {
          "title": "Créer un segment",
          "target": "Je veux cibler des personnes",
          "past": "Dans le passé",
          "addRule": "Ajouter une règle",
          "oneRuleMini": "Au moins une règle est nécessaire",
          "delete": "Supprimer le segment"
        }
      },
      "rules": {
        "VisitedWebsite": "qui a visité le site web",
        "VisitedUrl": "qui a visité une URL spécifique",
        "NotVisitedUrl": "qui n'a pas visité une URL spécifique",
        "VisitedUrlContaining": "qui a visité une URL contenant",
        "NotVisitedUrlContaining": "qui n'a pas visité une URL contenant"
      },
      "profiles": "Profils"
    },
    "statusWarning": "La campagne {{name}} est inactive.",
    "tabs": {
      "dashboard": "Tableau de bord",
      "events": "Analytics & Tracking",
      "segments": "Segments"
    },
    "updated": "La campagne a été mise à jour !",
    "segment": {
      "deleted": "Le segment a été supprimé"
    }
  },
  "adcopy": {
    "archived": "Votre créative a été archivée !",
    "addVariation": "Ajouter une variation",
    "create": "Créer une créative",
    "update": "Modifier une créative",
    "duplicate": "Dupliquer une créative",
    "duplicateInsteadOfUpdatePrefix": "Pour comparer les performances plus précisément, nous recommandons de",
    "duplicateInsteadOfUpdateLink": "dupliquer cette créative",
    "duplicateInsteadOfUpdateSuffix": "plutôt que de la modifier.",
    "created": "Votre créative a été créée !",
    "deleted": "Votre créative a été supprimée !",
    "updated": "Votre créative a été mise à jour !",
    "updateWarning": "Les changements seront effectifs dans maximum {{minutesNumber}} minutes",
    "settingsStep": "Paramètres",
    "forceRedirectUrl": "Url de redirection",
    "impressionPixels": "Pixels d'impression",
    "redirectUrl": "Redirect URL",
    "comments": "Commentaires",
    "advertiserName": "Nom de l'annonceur",
    "callToAction": "Call to Action",
    "copyWriting": "Creative",
    "creationMode": "Mode de creation",
    "creationModeShuffle": "Shuffle",
    "creationModeList": "Liste",
    "createVariantsInfo": "Vous pouvez créer jusqu'à {{max}} variations de votre créative en cliquant sur 'ajouter une variation' sur les champs disponibles.",
    "abtestSelected": "Créer un test A/B avec cette créative",
    "abTestWizardTitle": "Créer 4 variations depuis la créative",
    "sameImageReused": "Cette variation réutilise l'image d'origine de la créative sélectionnée.",
    "abTestExpectedFive": "Exactement 5 contenus sont requis (original + 4 variations).",
    "abTestTwoImagesRequired": "Veuillez ajouter 2 nouvelles images pour les variations 4 et 5.",
    "totalGeneratedAdCopies": "{{number}} Creative(s) au total",
    "cropImage": "Redimensionner l'image",
    "chooseImage": "Choisir une image",
    "availableSize": "Les tailles disponible sont :",
    "image": "Image",
    "idealSize": "la taille idéale est 1200 x 628 (largeur x hauteur)",
    "widthAndHeight": "(largeur x hauteur)",
    "noImage": "Aucune image",
    "cropNeeded": "Avant de continuer vous devez redimensionner votre image afin d'obtenir le bon ratio",
    "cropCloseWarning": "Fermer maintenant annulera le recadrage et supprimera cette image. Vous pouvez continuer a modifier pour la recadrer et l'enregistrer.",
    "sizeLimit": "La taille limite d'une image est de 2mb",
    "sizeMiniError": "L'image est en dessous de la taille minimale",
    "sizeMiniInfo": "La taille minimale est {{minWidth}} x {{minHeight}} (largeur x hauteur)",
    "sizeMiniWarning": "Attention: la taille de l'image sélectionnée est inférieure au minimum recommandé. L'image sera redimensionnée, ce qui peut entraîner une réduction de la qualité.",
    "imageCropperError": "Erreur lors du redimensionnement de l'image, réessayer ou contactez le support",
    "archiveConfirmation": "Voulez-vous vraiment archiver {{adCopyName}} ?",
    "cannotArchived": "Vous ne pouvez pas archiver cet créative car c'est le seul actif",
    "badResolution": "La résolution de l'image n'est pas valide",
    "adGroupOverride": "Ecraser les informations de l'adgroup",
    "adGroupOverrideTooltip": "Options spécifiques pour cette créative, par défaut les informations sont les mêmes que l'adgroup",
    "previewTable": {
      "title": "Créatives",
      "name": "Nom et aperçu",
      "weight": "Poids",
      "schedule": "Période",
      "scheduleFrom": "À partir du {{date}}",
      "scheduleUntil": "Jusqu'au {{date}}",
      "scheduleRange": "{{startDate}} → {{endDate}}",
      "duplicateDialogTitle": "Duplication de cette créative",
      "duplicateConfirmation": "Etes-vous sûr de vouloir dupliquer {{adCopyName}} ?",
      "createdAt": "Date de création",
      "updatedAt": "Dernière modification",
      "visualUpdatedAt": "Dernière modification visuelle",
      "dates": "Dates",
      "dateCreatedRelative": "Créée {{relative}}",
      "dateUpdatedRelative": "Modifiée {{relative}}",
      "dateTooltipSame": "Création et dernière modification visuelle : {{date}}",
      "dateTooltipCreated": "Création : {{date}}",
      "dateTooltipVisualUpdated": "Dernière modification visuelle : {{date}}",
      "since": "depuis le",
      "errorStatusTooltip": "Une erreur est survenue avec l'image actuelle. Veuillez la convertir au format JPG (renommer l'extension du fichier ne suffit pas) puis l'importer à nouveau."
    },
    "archivedFilter": {
      "label": "Statut",
      "allStatus": "Tous les statuts",
      "archived": "Archivés"
    },
    "wizzard": {
      "max": "Max {{max}} caractères - {{length}}/{{max}}",
      "betweenMinMax": "Doit contenir entre {{min}} et {{max}} caractères - {{length}}/{{max}}"
    },
    "dates": {
      "notToday": "Aucune créative active aujourd'hui",
      "startDateAndEndDateError": "Cet adgroup ne peut démarrer que le {{startDate}} et se terminera le {{endDate}}",
      "startDateError": "Seules les créatives avec une date de début future sont actives, cet adgroup ne peut démarrer que le {{startDate}}",
      "endDatesError": "Seules les créatives avec une date de fin sont actives, cet adgroup sera arrêté car aucune créative ne sera active après le {{endDate}}"
    },
    "containsText": "Cette image contient du texte. Nous vous recommandons d'utiliser des images sans texte pour obtenir de meilleures performances.",
    "keywordSuggestions": "Suggestions de mots-clés",
    "noKeywordSuggestions": "Aucune suggestion de mots-clés",
    "assistant": {
      "button": "Ai Assistant",
      "title": "Assistant IA",
      "refresh": "Rafraichir",
      "remaining": "{{count}} variations disponibles",
      "noSuggestions": "Aucune suggestion disponible.",
      "add": "Ajouter aux variations",
      "addAll": "Ajouter toutes les suggestions"
    },
    "statusManager": {
      "step1": "Voir les recommandations",
      "stepBudgets": "Budgets",
      "step2": "Mettre à jour les créatives actuelles",
      "stepAddNew": "Ajouter de nouvelles créatives",
      "stepOverview": "Aperçu et enregistrement",
      "budgetsStepTitle": "Budgets de l'adgroup",
      "action_adcopies": "Gérer le statut des créatives actives",
      "noActiveAdCopies": "Aucune créative active trouvée",
      "recommended": "Recommandé",
      "display": {
        "cards": "Cartes",
        "table": "Tableau"
      },
      "createNew": "Créer un nouveau contenu",
      "overviewStepTitle": "Aperçu avant l'enregistrement",
      "overviewBudgets": "Budgets",
      "overviewRuleBudgets": "Modifications de budget basées sur les règles",
      "overviewStatuses": "Créatives actives",
      "overviewNewAdCopies": "Nouvelles créatives à créer",
      "overviewAdGroupChanges": "Paramètres de budget",
      "overviewDemographicsChanges": "Ciblage démographique",
      "overviewGeoTargetingChanges": "Ciblage géographique",
      "overviewDeviceOsChanges": "Ciblage appareil et OS",
      "overviewTimeTargetingChanges": "Ciblage horaire",
      "overviewStatusUpdates": "Mises à jour de statut des créatives",
      "stepNoChanges": "Aucun changement",
      "statusWillChange": "Le statut sera mis à jour",
      "noStatusChanges": "Aucun changement de statut",
      "noChanges": "Aucun changement",
      "noRecommendation": "Tout est OK, aucune recommandation pour le moment.",
      "partialSave": "Certains changements ont été enregistrés. Erreurs : {{errors}}",
      "saveFailed": "Aucun changement enregistré. Erreurs : {{errors}}",
      "saved": "Tous les changements ont été enregistrés avec succès",
      "action": {
        "action_budget": "Paramètres de budget",
        "action_demographics": "Ciblage démographique",
        "action_geoTargeting": "Ciblage géographique",
        "action_deviceOs": "Ciblage appareil et OS",
        "action_timeTargeting": "Ciblage temporel",
        "action_adcopies": "Mettre à jour les créatives actuelles"
      },
      "pendingIntegration": {
        "demographics": "L'intégration du formulaire de ciblage démographique est en cours. Cette étape vous permettra de modifier le ciblage par genre et tranche d'âge en fonction des recommandations de règles.",
        "geoTargeting": "L'intégration du formulaire de ciblage géographique est en cours. Cette étape vous permettra de modifier le ciblage par pays, ville et région en fonction des recommandations de règles.",
        "deviceOs": "L'intégration du formulaire de ciblage par appareil et OS est en cours. Cette étape vous permettra de modifier le ciblage par type d'appareil et système d'exploitation en fonction des recommandations de règles.",
        "timeTargeting": "L'intégration du formulaire de ciblage temporel est en cours. Cette étape vous permettra de modifier le ciblage par jour et heure en fonction des recommandations de règles."
      }
    }
  },
  "adTemplate": {
    "Native": "Native",
    "Banner": "Banner",
    "Web": "Web",
    "notFound": "Template introuvable",
    "size": "Taille",
    "edit": "Éditer le template",
    "update": "Modifier un template",
    "duplicate": "Dupliquer ce template",
    "duplicated": "Votre template a été dupliqué !",
    "duplicateConfirmation": "Voulez-vous vraiment dupliquer {{adTemplateName}} ?",
    "deleteConfirmation": "Voulez-vous vraiment supprimer {{adTemplateName}} ?",
    "cannotDeleteAdTemplate": "Vous n'êtes pas autorisé à supprimer le seul template actif",
    "created": "Votre template a été créé !",
    "updated": "Votre template a été modifié !",
    "deleted": "Votre template a été supprimé !",
    "table": {
      "format": "Format"
    },
    "web": {
      "cssSelector": "Sélecteur CSS",
      "cssSelectorPosition": "Position du sélecteur CSS",
      "preview": "Aperçu du template",
      "editor": "Editeur de template Web",
      "masterTemplate": "Master",
      "zoneTemplate": "Zone",
      "js": "Javascript",
      "css": "Css",
      "beautify": "Mettre en forme le code"
    },
    "preview": {
      "desktopPreview": "Aperçu desktop",
      "mobilePreview": "Aperçu mobile",
      "failed": "Erreur: impossible de charger l'aperçu",
      "reload": "Recharger"
    },
    "create": {
      "title": "Créer un template"
    },
    "NotFound": "Template inconnu",
    "unknownFormat": "Ce type de template n'est pas géré par la plateforme",
    "updateWarning": "Les modifications seront activées dans un maximum de {{minutesNumber}} minutes"
  },
  "commons": {
    "accessType": "Gestion d'accès",
    "conversions": "Conversions",
    "priority": "Priorité",
    "actions": {
      "add": "Ajouter",
      "confirm": "Confirmer",
      "confirmTheAction": "Confirmer l'action",
      "confirmDuplicate": "Êtes-vous sûr de vouloir dupliquer {{name}} ?",
      "confirmArchive": "Êtes-vous sûr de vouloir archiver {{name}} ?",
      "cancel": "Annuler",
      "changePassword": "Changer de mot de passe",
      "close": "Fermer",
      "create": "Créer",
      "delete": "Supprimer",
      "duplicate": "Dupliquer",
      "downloadAsCsv": "Télécharger en CSV",
      "archive": "Archiver",
      "back": "Retour",
      "edit": "Éditer",
      "filter": "Filtrer",
      "hoverEditHelper": "Cliquez sur les boutons ci-dessous pour activer/désactiver les éléments",
      "moreOptions": "Plus d'options",
      "save": "Sauvegarder",
      "selectAll": "Tout Selectionner",
      "deselectAll": "Tout Déselectionner",
      "activate": "Activer",
      "disable": "Désactiver",
      "reject": "Rejeter",
      "quitWithoutSaving": "Quitter sans sauvegarder",
      "selectFile": "Choisir un fichier",
      "showMore": "Afficher plus",
      "showLess": "Afficher moins",
      "exportToXlsx": "Exporter en fichier Excel"
    },
    "sort": "Tri",
    "actionsTitle": "Actions",
    "active": "Actif",
    "inactive": "Inactif",
    "paused": "Pause",
    "pending": "En attente",
    "nobudgetleft": "Pas de budget disponible",
    "pendingvalidation": "En attente de validation",
    "rejected": "Rejeté",
    "processing": "En cours de traitement",
    "waiting": "En attente",
    "archived": "Archivé",
    "ended": "Terminé",
    "startsoon": "Commencera bientôt",
    "activityfeed": "Flux d'activitées",
    "autoReload": {
      "label": "Rechargement auto",
      "off": "Désactivé"
    },
    "adgroup": "Adgroup",
    "adgroups": "Adgroups",
    "all": "Tous",
    "admin": "Administrateur",
    "campaign": "Campagne",
    "campaigns": "Campagnes",
    "companies": "Entreprises",
    "comingSoon": "Cette fonctionnalité sera bientôt disponible",
    "companyName": "Compagnie",
    "create": "Créer",
    "creative": "Créative",
    "days": "Jours",
    "dashboard": "Tableau de bord",
    "default": "Par défaut",
    "details": "Détails",
    "desktop": "Ordinateur",
    "deleted": "Supprimé",
    "disabled": "Désactivé",
    "domainFormatError": "Veuillez vérifier que votre domaine est au bon format",
    "email": "Email",
    "emptyData": "Aucune donnée n'a été trouvée",
    "emptyField": "Aucun",
    "entityType": "Type d'entité",
    "enabled": "Activé",
    "endDateValidation": "La date de fin ne peut pas être avant la date de début",
    "errorOccurred": "Une erreur est survenue",
    "exclude": "exclu(e)",
    "firstName": "Prénom",
    "format": "format",
    "fullName": "Nom",
    "goTo": "Allez à {{item}}",
    "iabCategory": "Catégorie IAB",
    "recommendedIabCategoryAlert": "Catégorie IAB recommandée : {{category}}",
    "id": "ID",
    "include": "inclus(e)",
    "integer": "La valeur doit être un nombre entier",
    "invited": "Invité",
    "invalidUrl": "URL invalide",
    "urlCheck": {
      "redirectsTo": "Cette URL redirige vers {{url}}",
      "redirectDetected": "Cette URL redirige ailleurs (destination illisible)",
      "httpError": "La vérification de l'URL a échoué avec le code HTTP {{status}}",
      "expiredCertificate": "Impossible de vérifier l'URL : le certificat SSL du site a expiré",
      "requestFailed": "Impossible de vérifier l'URL (erreur réseau ou blocage du navigateur)"
    },
    "status": "Statut",
    "derivedStatus": {
      "adGroups": "Ce statut reflète uniquement le statut des adgroups. Il est actif dès qu'au moins un adgroup est actif. Pour le désactiver, désactivez tous les adgroups.",
      "positions": "Ce statut reflète uniquement le statut des positions. Il est actif dès qu'au moins une position est active. Pour le désactiver, désactivez toutes les positions."
    },
    "lastName": "Nom",
    "login": "Connexion",
    "manager": "Manager",
    "market": "Marché",
    "mobile": "Mobile",
    "modified": "Modifié",
    "nonArchived": "Non archivé",
    "saved": "Vos changements ont été sauvegardé",
    "savedWithDelay": "Les modifications seront activées dans un délai maximum de {{minutesNumber}} minutes",
    "name": "Nom",
    "noValueYet": "Pas encore de valeur",
    "no": "Non",
    "noDataToDisplay": "Rien n'a encore été sélectionné",
    "password": "Mot de passe",
    "publishers": "Publishers",
    "phone": "Téléphone",
    "primaryContact": "Contact principal",
    "pageNumber": "Page n°{{currentPage}}",
    "reports": "Rapports",
    "reseller": "Revendeur",
    "required": "Champs requis",
    "retry": "Réessayer",
    "rowsPerPage": "lignes par page",
    "startDate": "Date de début",
    "endDate": "Date de fin",
    "settingsTitle": "Paramètres",
    "paginationDisplayedRows_one": "{{from}}–{{to}} sur 1",
    "paginationDisplayedRows_other": "{{from}}–{{to}} sur {{count}}",
    "atLeastOneOption": "Sélectionnez au moins une option",
    "budget": "Budget",
    "settings": "paramètres",
    "stepper": {
      "back": "Revenir en arrière",
      "next": "Suivant",
      "skip": "Passer",
      "submit": "Envoyer",
      "submitting": "En cours d'envoi",
      "checkRecommendations": "Vérifier ces recommandations"
    },
    "title": "Titre",
    "description": "Description",
    "tooltips": {
      "limitExceeded": "autre(s) élément(s)"
    },
    "user": "user",
    "users": "Utilisateurs",
    "unknown": "Inconnu(e)",
    "unsavedModifications": "Champs avec des modifications non enregistrées :",
    "unsavedChangesWarning": "Êtes-vous sûr de vouloir quitter cette page sans sauvegarder ?",
    "closeDialogWithoutSaving": "Êtes-vous sûr de vouloir fermer cette boîte de dialogue sans enregistrer ?",
    "websites": "Sites Web",
    "hour": "Heure",
    "day": "Jour",
    "week": "Semaine",
    "month": "Mois",
    "year": "Année",
    "yes": "Oui",
    "validation": {
      "minWithCount": "{{name}} doit contenir au moins {{min}} caractères - {{length}}/{{max}}",
      "maxWithCount": "{{name}} doit contenir au plus {{max}} caractères - {{length}}/{{max}}",
      "numberMin": "doit être plus grand ou égal {{min}}",
      "numberMax": "doit être plus petit ou égal à {{max}}"
    },
    "error": "Erreur",
    "adTemplates": "Templates",
    "noDataAvailable": "Aucune donnée disponible",
    "errors": {
      "generic": "Une erreur est survenue"
    },
    "revenue": "Revenues",
    "ctr": "CTR",
    "cpm": "CPM",
    "clicks": "Clicks",
    "impressions": "Impressions",
    "leads": "Leads",
    "orders": "Commandes",
    "costs": "Coûts",
    "adcopies": "créatives",
    "toolbar": {
      "selectedCount_one": "{{count}} sélectionné",
      "selectedCount_other": "{{count}} sélectionnés"
    },
    "paginationDisplayedRows_many": "{{from}}–{{to}} sur {{count}}"
  },
  "company": {
    "billing": {
      "bankDetails": "Coordonnées bancaires",
      "bankName": "Bank Name",
      "currency": "Default currency",
      "edit": {
        "title": "Edition des billing details"
      },
      "iban": "IBAN",
      "invoiceLanguage": "Invoice language",
      "invoiceSettings": "Paramètres de facturation",
      "invoicingCompany": "Entité de facturation",
      "paymentTerm": "Payment terms",
      "sectionTitle": "Billing",
      "stepperTitle": "Billing details",
      "swift": "SWIFT / BIC"
    },
    "billingContacts": {
      "createDialogTitle": "Créer un billing contact",
      "created": "Le billing contact a bien été créé",
      "deleteConfirm": "Vous êtes sur le point de supprimer le billing contact suivant: {{firstName}} {{lastName}}. \nÊtes-vous sûr de vouloir continuer ?",
      "deleteDialogTitle": "Confirmation de suppression du billing contact",
      "helperTooltip": "Contacts supplémentaires pour la facturation / les notifications de factures",
      "sectionTitle": "Billing contacts"
    },
    "cgu": {
      "accept": "Accepter",
      "accepted": "Accepté",
      "acceptCguMessage": "Pour continuer à utiliser l'application, vous devez accepter nos Conditions Générales d'Utilisation.",
      "inherited": {
        "agency": "Ces conditions sont gérées par l'agence parente.",
        "agencyOrReseller": "Ces conditions sont gérées par l'agence ou le revendeur parent.",
        "link": "Consultez-les sur cette entité.",
        "reseller": "Ces conditions sont gérées par le revendeur parent."
      },
      "newCguVersionMessage": "Nos Conditions Générales d'Utilisation ont été mises à jour. Veuillez lire la nouvelle version et l'accepter pour continuer à utiliser nos services.",
      "notAccepted": "Pas encore accepté"
    },
    "create": "Créer une Company",
    "created": "La company a été créé avec succès",
    "usersHelper": "Ajoutez éventuellement des utilisateurs à la nouvelle company. Vous pouvez en ajouter plusieurs avant de terminer la création.",
    "details": {
      "accountingId": "Accounting ID",
      "address": "Adresse",
      "city": "Ville",
      "companyType": "Type de compagnie",
      "contact": "Contact",
      "copperOpportunity": "Opportunité",
      "copperOpportunityStage": "Étape d'opportunité Copper",
      "country": "Pays",
      "edit": {
        "title": "Édition des informations de l'entreprise",
        "vatHelper": "Le numéro de TVA est validé selon le pays."
      },
      "fax": "Fax",
      "nameAndGeneric": "Nom (Nom générique)",
      "genericName": "Nom générique",
      "map": "Carte",
      "name": "Nom de l'entreprise",
      "nameAlreadyExists": "Une entreprise portant ce nom existe déjà",
      "phone": "Téléphone",
      "agency": "Agence",
      "reseller": "Revendeur",
      "resellerId": "Revendeur",
      "resellerName": "Revendeur",
      "sectionTitle": "Détails de l'entreprise",
      "slug": "Sous-domaine de l'entreprise",
      "stepperTitle": "Détails de l'entreprise",
      "taxDetails": "Détails fiscaux",
      "taxId": "Numéro fiscal",
      "type": "Type",
      "vatId": "Numéro de TVA",
      "website": "Site web",
      "zipCode": "Code postal"
    },
    "managers": {
      "accountManager": "Account manager",
      "salesManager": "Sales manager",
      "stepperTitle": "Managers"
    },
    "rights": {
      "api": "API",
      "web": "Canal web",
      "adgroupCpm": "CPM",
      "adgroupCpl": "CPL",
      "adgroupCpc": "CPC",
      "adgroupExclusions": "Restriction de diffusion",
      "adgroupCustomcpcs": "Ajustements d'enchères",
      "adgroupReportwebsites": "Voir le rapport par site Web",
      "adgroupUsertargeting": "Ciblage démographique des utilisateurs",
      "adgroupGeotargeting": "Ciblage géographique des utilisateurs",
      "adgroupDevicetargeting": "Ciblage des appareils des utilisateurs",
      "adgroupTimetargeting": "Ciblage horaire et quotidien des utilisateurs",
      "adgroupPriority": "Priorité des AdGroup",
      "adgroupMonthlyBudgetCapping": "Mensuel",
      "adgroupOverallBudgetCapping": "Global",
      "adgroupOpenBudgetCapping": "Sans limite",
      "adgroupPeriodBudgetCapping": "Période",
      "adgroupBudgetCapping": "Plafond budgétaire",
      "adgroupOpenDailyBudget": "Budget journalier ouvert",
      "adgroupDatesRequired": "Dates de début et de fin obligatoires",
      "costSettings": "Paramètres de coût",
      "budgetCappingSettings": "Paramètres de plafond budgétaire",
      "disabledRequiresBudgetCapping": "Activez le plafond budgétaire pour modifier cette permission.",
      "adgroupSegments": "AdGroup segments CRM",
      "adgroupAutoSegments": "AdGroup auto-segments",
      "adCopyDates": "Dates des AdCopy",
      "positionAdvancedsettings": "Paramètres avancés des positions (CPM plancher, partage de revenue)",
      "websiteExclusions": "Liste noire des sites web",
      "advertiserDirectoryPresets": "Presets de restriction de diffusion",
      "publisherBlacklistPresets": "Presets de liste noire",
      "description": {
        "api": "Affichage de la page de token et routes de l'API",
        "web": "Affichage du canal web",
        "banner": "Affichage du template bannière",
        "adgroupCpm": "Affichage du coût CPM",
        "adgroupCpl": "Affichage du coût CPL",
        "adgroupExclusions": "Affichage de la page de restriction de diffusion ou du ciblage des sites web et positions pour les AdGroups",
        "adgroupCustomcpcs": "Affichage de la page pour ajouter des prix personnalisés par site, appareil ou catégorie IAB",
        "adgroupReportwebsites": "Page de statistiques des AdGroup par site web visible.",
        "adgroupUsertargeting": "Affichage du ciblage des utilisateurs (âge et genre) visible.",
        "adgroupGeotargeting": "Affichage du ciblage géographique des utilisateurs visible.",
        "adgroupDevicetargeting": "Affichage du ciblage des appareils des utilisateurs visible.",
        "adgroupTimetargeting": "Affichage du ciblage horaire et quotidien visible.",
        "adgroupPriority": "Permet à ce revendeur de prioriser ses publicités avant Powerspace.",
        "adgroupMonthlyBudgetCapping": "Autoriser le plafond budgétaire mensuel sur les adgroups.",
        "adgroupOverallBudgetCapping": "Autoriser le plafond budgétaire global sur les adgroups.",
        "adgroupOpenBudgetCapping": "Autoriser le plafond budgétaire ouvert (illimité) sur les adgroups.",
        "adgroupBudgetCapping": "Autoriser le type et le montant de plafond budgétaire sur les adgroups.",
        "adgroupOpenDailyBudget": "Autoriser le budget journalier ouvert sur les adgroups.",
        "adgroupDatesRequired": "Rendre obligatoires les dates de début et de fin sur les adgroups.",
        "costSettings": "Types de coût autorisés pour les adgroups. Le CPC est toujours activé ; le CPM et le CPL sont optionnels.",
        "budgetCappingSettings": "Types de plafond budgétaire autorisés pour les adgroups. La période est toujours activée ; mensuel, global et ouvert sont optionnels.",
        "adgroupSegments": "Page de segments CRM et activation dans les adgroups.",
        "adgroupAutoSegments": "Activation des auto-segments visible.",
        "adCopyDates": "Activation de l'utilisation des dates de début et de fin sur les AdCopy.",
        "positionAdvancedsettings": "Page de réglage des paramètres avancés des positions (CPM plancher, partage de revenu) visible.",
        "websiteExclusions": "Affichage de la page de liste noire des sites web.",
        "advertiserDirectoryPresets": "Créer et gérer les presets de restriction de diffusion.",
        "publisherBlacklistPresets": "Créer, assigner et convertir les presets de liste noire."
      },
      "admin": "Admin",
      "edit": "Écriture",
      "read": "Lecture",
      "sectionTitle": "Droits et accès",
      "uiRightsMainTitle": "Accès principal",
      "uiRightsTitle": "Droits d'accès",
      "banner": "Template bannière",
      "groups": {
        "adCopy": "AdCopy",
        "position": "Position",
        "website": "Site web",
        "presets": "Presets",
        "apiAccess": "API",
        "channels": "Canaux",
        "budget": "Budget",
        "targeting": "Ciblage",
        "segments": "Segments",
        "broadcast": "Diffusion et enchères",
        "priority": "Priorité"
      },
      "inherited": {
        "agency": "Ces droits sont gérés par l'agence parente. Consultez-les sur cette entité.",
        "reseller": "Ces droits sont gérés par le revendeur parent. Consultez-les sur cette entité.",
        "agencyOrReseller": "Ces droits sont gérés par l'agence ou le revendeur parent. Consultez-les sur ces entités.",
        "generic": "Ces droits ne peuvent pas être modifiés ici."
      },
      "presets": {
        "label": "Préréglage des droits",
        "title": "Préréglages de droits",
        "description": "Applique un ensemble prédéfini de permissions annonceur. Les changements ne sont pris en compte qu'après enregistrement.",
        "self": "Self",
        "managed": "Managed",
        "all": "All"
      }
    },
    "users": {
      "accessType": "Niveau de droits",
      "actions": "Actions",
      "createUser": "Créer un utilisateur",
      "created": "L'utilisateur a bien été créé",
      "deleted": "L'utilisateur a bien été supprimé",
      "deleteConfirm": "Vous êtes sur le point de supprimer définitivement l'utilisateur suivant: {{firstName}} {{lastName}}\nVoulez-vous vraiment continuer?\n\nUne fois supprimées, toutes les informations de contact et de connexion concernant cet utilisateur seront supprimées.",
      "deleteDialogTitle": "Confirmation de la suppression de l'utilisateur",
      "edit": {
        "form": {
          "changePassword": "Changer de mot de passe",
          "passwordUpdated": "Votre mot de passe a été modifié avec succès",
          "errors": {
            "digit": "Un chiffre",
            "lowercase": "Une lettre minuscule",
            "max": "Maximum {{max}} caractères",
            "min": "Minimum {{min}} caractères",
            "special": "Un caractère spécial",
            "uppercase": "Une lettre majuscule"
          },
          "newPassword": "Nouveau mot de passe",
          "passwordSecure": "Votre mot de passe est sécurisé !",
          "passwordBestPractices": {
            "title": "Bonnes pratiques pour les mots de passe",
            "passphrase": "Utilisez une phrase de passe longue composée de plusieurs mots sans lien entre eux.",
            "reuse": "Ne réutilisez pas un mot de passe déjà utilisé sur d'autres sites.",
            "personalInfo": "Évitez les informations personnelles comme votre nom, votre entreprise ou votre adresse e-mail.",
            "passwordManager": "Pensez à utiliser un gestionnaire de mots de passe pour générer et stocker vos mots de passe."
          }
        },
        "title": "Éditer l'utilisateur"
      },
      "email": "Email",
      "emailAlreadyUsed": "Cet email est déjà utilisé",
      "externalAccess": {
        "agency": "Agence",
        "revokeAccess": "Révoquer l'accès",
        "title": "Accès Externe"
      },
      "firstName": "Prénom",
      "invite": "Inviter un utilisateur",
      "invited": "L'utilisateur a été invité",
      "sendInvitation": "Envoyer une invitation",
      "isAdmin": "Admin",
      "jobTitle": "Poste",
      "lastName": "Nom",
      "language": "Langue",
      "languages": {
        "en": "Anglais",
        "fr": "Français",
        "it": "Italien"
      },
      "mobile": "Téléphone",
      "passwordValidation": "Validation du mot de passe",
      "primaryContact": "Contact principal",
      "primaryContactYes": "Oui",
      "primaryContactNo": "Non",
      "sectionTitle": "Utilisateur",
      "stepperTitle": "Utilisateurs",
      "userInfos": "Informations utilisateur",
      "preferences": "Préférences",
      "market": "Marché par défaut",
      "roles": "Rôles"
    },
    "statusWarning": "L'entreprise {{name}} est inactive.",
    "tabs": {
      "billing": "Facturation",
      "users": "Utilisateurs",
      "access": "Permissions",
      "terms": "Termes et conditions",
      "api": "API",
      "directoryPresets": "Presets de restriction de diffusion",
      "revshare": "Revshare"
    },
    "revshare": {
      "averageTitle": "Revenue share moyen",
      "website": "Site web",
      "aboveAverage": "Au-dessus de la moyenne",
      "belowAverage": "En dessous de la moyenne",
      "bulkUpdateAction": "Mettre à jour le revshare sélectionné",
      "bulkUpdateTitle": "Mettre à jour le revenue share",
      "bulkUpdateSubmit_one": "Appliquer à {{count}} position",
      "bulkUpdateSubmit_other": "Appliquer à {{count}} positions",
      "bulkUpdateSubmit_many": "Appliquer à {{count}} positions"
    },
    "settings": {
      "defaultPriority": "Priorité par defaut",
      "defaultPriorityHelper": "Priorité utilisée par defaut pour vos AdGroups",
      "priorities": "Prioritées des AdGroup",
      "addPriority": "Ajouter une priorité",
      "priorityDefaultName": "Nouvelle Priorité",
      "duplicatePriorities": "Le même nom est utilisé plusieurs fois",
      "usedPriorityDeletion": "Impossible de supprimer une priorité utilisée",
      "defaultPriorityDeletion": "Impossible de supprimer la priorité utilisée par defaut",
      "priorityIndexHelper": "Un AdGroup avec la priorité 1 sera affiché avant un AdGroup avec une priorité 2",
      "movePriorityUp": "Monter la priorité",
      "movePriorityDown": "Descendre la priorité",
      "bannerSizes": "Tailles de bannière",
      "addBannerSize": "Ajouter une taille de bannière",
      "addBannerSizeModalTitle": "Ajouter une taille de bannière",
      "uploadBannerImage": "Importer une image",
      "uploadBannerImageHelper": "Importez une image de bannière pour détecter sa largeur et sa hauteur, puis ajustez les valeurs si nécessaire.",
      "bannerImageUploadError": "Impossible de lire l'image importée.",
      "duplicateBannerSizes": "Les mêmes dimensions sont utilisées plusieurs fois",
      "invalidBannerSize": "La largeur et la hauteur doivent être des nombres entiers positifs",
      "bannerSizesEmpty": "Aucune taille de bannière configurée",
      "bannerSizePreview": "Aperçu"
    },
    "copper": {
      "sectionTitle": "Copper"
    },
    "archiver": {
      "title": "Archivage automatique",
      "helper": "Les valeurs héritées de l'agence et du revendeur parent sont affichées automatiquement pour les annonceurs. Saisissez 0 pour désactiver l'archivage automatique pour ce type d'entité.",
      "inherit": "Hériter du revendeur",
      "unit_one": "mois",
      "unit_other": "mois",
      "disabled": "Désactivé",
      "invalidMonths": "Saisissez un nombre entier de mois supérieur ou égal à 0.",
      "months_one": "{{count}} mois",
      "months_other": "{{count}} mois",
      "fields": {
        "adcopyMonths": "Créations",
        "adgroupMonths": "Ad groups",
        "adtemplateMonths": "Modèles publicitaires",
        "positionMonths": "Positions"
      },
      "months_many": "{{count}} mois",
      "unit_many": "mois"
    },
    "webhooks": {
      "title": "Webhooks",
      "url": "URL du webhook",
      "types": "Types d'événements",
      "urlHelper": "Votre endpoint reçoit une requête POST avec un payload JSON lorsqu'un statut d'ad group change.",
      "eventType": "Type d'événement",
      "eventTypeHelper": "Événement : {{eventType}}. Nom de l'événement du payload : adgroup.status.changed.",
      "addWebhook": "Ajouter un webhook",
      "saveSuccess": "Webhooks enregistrés avec succès.",
      "deleteSuccess": "Webhook supprimé avec succès.",
      "invalidUrl": "Veuillez saisir une URL valide",
      "typesRequired": "Sélectionnez au moins un type d'événement",
      "duplicateUrls": "La même URL est utilisée plusieurs fois",
      "empty": "Aucun webhook configuré",
      "documentation": {
        "title": "Documentation",
        "open": "Documentation",
        "versionLabel": "Version",
        "versionOption": "Version {{version}}"
      }
    },
    "api": {
      "token": {
        "title": "Jetons API",
        "create": "Créer un nouveau jeton",
        "token": "Jeton",
        "createdAt": "Date de création",
        "empty": "Aucun token"
      },
      "routes": {
        "title": "Routes",
        "noData": "Aucune donnée pour cette date",
        "parameter": {
          "date": "Doit être la date des données que vous souhaitez obtenir au format YYYY-MM-DD",
          "dateIcon": "Changer la date",
          "token": "Peut être remplacé par n'importe quel jeton de l'entreprise."
        }
      }
    }
  },
  "enum": {
    "AdFormat": {
      "Banner": "Banner",
      "Native": "Native",
      "Web": "Web"
    },
    "BiddingStrategy": {
      "MaxCpm": "Holistic Bidding (Maximize CPM)"
    },
    "ChannelType": {
      "Email": "Email",
      "Web": "Web"
    },
    "CompanyType": {
      "Advertiser": "Advertiser",
      "Agency": "Agence",
      "Publisher": "Publisher",
      "Reseller": "Reseller",
      "TradingDesk": "Trading Desk"
    },
    "CompanyWebhookType": {
      "AdGroupStatus": "AdGroup status"
    },
    "EntityType": {
      "AdCopy": "Créative",
      "AdGroup": "Adgroup",
      "AdGroupBudgetPlan": "Budget Plannifié",
      "AdGroupTargeting": "Ciblage Adgroup",
      "AdTemplate": "Ad template",
      "AdTemplateBanner": "Template bannière",
      "AdTemplateImage": "Template image",
      "AdTemplateNative": "Template native",
      "AdTemplateWeb": "Template web",
      "AdgroupCustomCost": "Coût personnalisé",
      "AdgroupDirectory": "Restriction de diffusion",
      "AdgroupNetworkExtension": "Réseau Adgroup",
      "AdgroupWebsiteDirectory": "Répertoire Adgroup",
      "AdgroupWebsiteExclusion": "Répertoire Adgroup",
      "Advertiser": "Advertiser",
      "Agency": "Agence",
      "BillingContact": "Contact de facturation",
      "Campaign": "Campagne",
      "Company": "Entreprise",
      "CompanyApiToken": "Jeton API",
      "CompanyArchiver": "Politique d'archivage automatique",
      "CompanyWebhook": "Webhook",
      "InventorySelection": "Sélection d'inventaire",
      "Position": "Position",
      "PositionEmail": "Position",
      "PositionWeb": "Position",
      "ProgrammaticCampaign": "Campagne programmatique",
      "Publisher": "Publisher",
      "PublisherExclusionPreset": "Liste d'exclusions",
      "Reseller": "Reseller",
      "Segment": "Segment",
      "SegmentBehavioural": "Segment",
      "SegmentFile": "Segment",
      "TradingDesk": "Trading desk",
      "User": "Utilisateur",
      "Website": "Site web",
      "WebsiteCampaignExclusion": "Exclusion de campagne",
      "WebsiteDomainExclusion": "Exclusion de domaine",
      "WebsiteIabExclusion": "Exclusion IAB",
      "AdGroupDirectoryPreset": "Preset de restriction"
    },
    "Currency": {
      "EUR": "EUR"
    },
    "genre": {
      "female": "Femme",
      "male": "Homme"
    },
    "IntegrationType": {
      "Direct": "Direct"
    },
    "InvoiceLanguage": {
      "en": "Anglais",
      "fr": "Français"
    },
    "InvoicingCompany": {
      "PowerspaceSAS": "Powerspace SAS",
      "WelcomeMediaSAS": "Welcome Media SAS"
    },
    "Network": {
      "Ecommerce": "Ecommerce",
      "Eshopper": "Eshopper",
      "Media": "Media",
      "Performance": "Performance",
      "Ebusiness": "Ebusiness"
    },
    "PositionType": {
      "InContent": "Dans le contenu",
      "InFeed": "Dans un flux",
      "RecommandationWidget": "Widget de recommandation",
      "SideContent": "Contenu secondaire"
    },
    "SubChannelType": {
      "ConfirmationPage": "Page de confirmation",
      "Newsletter": "Newsletter",
      "OrderConfirmationEmail": "Email de confirmation d'une commande",
      "ProductListing": "Liste de produits"
    },
    "SslStatus": {
      "Invalid": "Invalide",
      "NotLinked": "Non lie",
      "Pending": "En attente",
      "Valid": "Valide"
    },
    "AdvertiserGestion": {
      "Self": "Self",
      "Managed": "Managé"
    },
    "AdvertiserType": {
      "Direct": "Direct",
      "AgencyPerformance": "Agence Performance",
      "AgencyMedia": "Agence Media ",
      "AffiliationPlatform": "Plateforme d'affiliation"
    },
    "UserRole": {
      "Finance": "Finance",
      "Marketing": "Marketing",
      "Sales": "Sales",
      "PublisherAccount": "Publisher Account",
      "Tech": "Tech",
      "Traffic": "Traffic"
    },
    "BudgetCapping": {
      "Monthly": "Mensuel",
      "Overall": "Global",
      "Open": "Sans limite",
      "Period": "Période"
    },
    "Gender": {
      "Male": "Homme",
      "Female": "Femme",
      "Unknown": "Inconnu(e)"
    },
    "DeviceType": {
      "Desktop": "Ordinateur",
      "Mobile": "Mobile",
      "Tablet": "Tablette",
      "Unknown": "Inconnu(e)"
    },
    "OsType": {
      "Android": "Android",
      "Ios": "iOS",
      "Macos": "macOS",
      "Windows": "Windows",
      "Unknown": "Inconnu(e)"
    },
    "Day": {
      "Monday": "Lundi",
      "Tuesday": "Mardi",
      "Wednesday": "Mercredi",
      "Thursday": "Jeudi",
      "Friday": "Vendredi",
      "Saturday": "Samedi",
      "Sunday": "Dimanche"
    }
  },
  "iabCategories": {
    "IAB1": "Arts & Divertissement",
    "IAB1-1": "Livres & Littérature",
    "IAB1-2": "Célébrités/Potins",
    "IAB1-3": "Beaux-Arts",
    "IAB1-4": "Humour",
    "IAB1-5": "Films",
    "IAB1-6": "Musique",
    "IAB1-7": "Télévision",
    "IAB10": "Maison & Jardin",
    "IAB10-1": "Électroménager",
    "IAB10-2": "Réception",
    "IAB10-3": "Sécurité environnementale",
    "IAB10-4": "Jardinage",
    "IAB10-5": "Bricolage",
    "IAB10-6": "Home Cinéma",
    "IAB10-7": "Décoration d'intérieur",
    "IAB10-8": "Aménagement paysager",
    "IAB10-9": "Rénovation & Construction",
    "IAB11": "Droit, Gouvernement & Politique",
    "IAB11-1": "Immigration",
    "IAB11-2": "Questions juridiques",
    "IAB11-3": "Ressources gouvernementales américaines",
    "IAB11-4": "Politique",
    "IAB11-5": "Commentaires",
    "IAB12": "Actualités",
    "IAB12-1": "Actualités internationales",
    "IAB12-2": "Actualités nationales",
    "IAB12-3": "Actualités locales",
    "IAB13": "Finances personnelles",
    "IAB13-1": "Initiation à l'investissement",
    "IAB13-10": "Planification de la retraite",
    "IAB13-11": "Actions",
    "IAB13-12": "Planification fiscale",
    "IAB13-2": "Crédit/Dette & Prêts",
    "IAB13-3": "Actualités financières",
    "IAB13-4": "Planification financière",
    "IAB13-5": "Fonds spéculatif",
    "IAB13-6": "Assurance",
    "IAB13-7": "Investissement",
    "IAB13-8": "Fonds communs de placement",
    "IAB13-9": "Options",
    "IAB14": "Société",
    "IAB14-1": "Rencontres",
    "IAB14-2": "Soutien divorce",
    "IAB14-3": "Vie homosexuelle",
    "IAB14-4": "Mariage",
    "IAB14-5": "Vie des seniors",
    "IAB14-6": "Adolescents",
    "IAB14-7": "Mariages",
    "IAB14-8": "Spécificités ethniques",
    "IAB15": "Science",
    "IAB15-1": "Astrologie",
    "IAB15-10": "Météo",
    "IAB15-2": "Biologie",
    "IAB15-3": "Chimie",
    "IAB15-4": "Géologie",
    "IAB15-5": "Phénomènes paranormaux",
    "IAB15-6": "Physique",
    "IAB15-7": "Espace/Astronomie",
    "IAB15-8": "Géographie",
    "IAB15-9": "Botanique",
    "IAB16": "Animaux de compagnie",
    "IAB16-1": "Aquariums",
    "IAB16-2": "Oiseaux",
    "IAB16-3": "Chats",
    "IAB16-4": "Chiens",
    "IAB16-5": "Grands animaux",
    "IAB16-6": "Reptiles",
    "IAB16-7": "Médecine vétérinaire",
    "IAB17": "Sports",
    "IAB17-1": "Course automobile",
    "IAB17-10": "Patinage artistique",
    "IAB17-11": "Pêche à la mouche",
    "IAB17-12": "Football",
    "IAB17-13": "Pêche en eau douce",
    "IAB17-14": "Chasse & Pêche",
    "IAB17-15": "Golf",
    "IAB17-16": "Courses hippiques",
    "IAB17-17": "Chevaux",
    "IAB17-18": "Chasse/Tir",
    "IAB17-19": "Roller",
    "IAB17-2": "Baseball",
    "IAB17-20": "Arts martiaux",
    "IAB17-21": "VTT",
    "IAB17-22": "Course NASCAR",
    "IAB17-23": "Jeux olympiques",
    "IAB17-24": "Paintball",
    "IAB17-25": "Motos & Véhicules motorisés",
    "IAB17-26": "Basketball pro",
    "IAB17-27": "Hockey sur glace pro",
    "IAB17-28": "Rodéo",
    "IAB17-29": "Rugby",
    "IAB17-3": "Cyclisme",
    "IAB17-30": "Course à pied/Jogging",
    "IAB17-31": "Voile",
    "IAB17-32": "Pêche en mer",
    "IAB17-33": "Plongée sous-marine",
    "IAB17-34": "Skateboard",
    "IAB17-35": "Ski",
    "IAB17-36": "Snowboard",
    "IAB17-37": "Surf/Bodyboard",
    "IAB17-38": "Natation",
    "IAB17-39": "Tennis de table/Ping-pong",
    "IAB17-4": "Musculation",
    "IAB17-40": "Tennis",
    "IAB17-41": "Volleyball",
    "IAB17-42": "Marche",
    "IAB17-43": "Ski nautique/Wakeboard",
    "IAB17-44": "Football mondial",
    "IAB17-5": "Boxe",
    "IAB17-6": "Canoë/Kayak",
    "IAB17-7": "Cheerleading",
    "IAB17-8": "Escalade",
    "IAB17-9": "Cricket",
    "IAB18": "Style & Mode",
    "IAB18-1": "Beauté",
    "IAB18-2": "Art corporel",
    "IAB18-3": "Mode",
    "IAB18-4": "Bijoux",
    "IAB18-5": "Vêtements",
    "IAB18-6": "Accessoires",
    "IAB19": "Technologie & Informatique",
    "IAB19-1": "Graphisme 3D",
    "IAB19-10": "Tests d'ordinateurs",
    "IAB19-11": "Centres de données",
    "IAB19-12": "Bases de données",
    "IAB19-13": "Publication assistée par ordinateur",
    "IAB19-14": "Vidéo sur ordinateur",
    "IAB19-15": "Email",
    "IAB19-16": "Logiciels graphiques",
    "IAB19-17": "Vidéo domestique/DVD",
    "IAB19-18": "Technologie Internet",
    "IAB19-19": "Java",
    "IAB19-2": "Animation",
    "IAB19-20": "JavaScript",
    "IAB19-21": "Support Mac",
    "IAB19-22": "MP3/MIDI",
    "IAB19-23": "Conférence en ligne",
    "IAB19-24": "Internet pour débutants",
    "IAB19-25": "Sécurité réseau",
    "IAB19-26": "Ordinateurs de poche/PDA",
    "IAB19-27": "Support PC",
    "IAB19-28": "Portable",
    "IAB19-29": "Divertissement",
    "IAB19-3": "Logiciels antivirus",
    "IAB19-30": "Shareware/Freeware",
    "IAB19-31": "Unix",
    "IAB19-32": "Visual Basic",
    "IAB19-33": "Cliparts web",
    "IAB19-34": "Design web/HTML",
    "IAB19-35": "Recherche web",
    "IAB19-36": "Windows",
    "IAB19-4": "C/C++",
    "IAB19-5": "Appareils photo & Caméscopes",
    "IAB19-6": "Téléphones portables",
    "IAB19-7": "Certification informatique",
    "IAB19-8": "Réseaux informatiques",
    "IAB19-9": "Périphériques informatiques",
    "IAB2": "Automobile",
    "IAB2-1": "Pièces auto",
    "IAB2-10": "Véhicule électrique",
    "IAB2-11": "Berline compacte",
    "IAB2-12": "Hybride",
    "IAB2-13": "Luxe",
    "IAB2-14": "Monospace",
    "IAB2-15": "Motos",
    "IAB2-16": "Véhicules tout-terrain",
    "IAB2-17": "Véhicules performants",
    "IAB2-18": "Pick-up",
    "IAB2-19": "Assistance routière",
    "IAB2-2": "Réparation auto",
    "IAB2-20": "Berline",
    "IAB2-21": "Camions & Accessoires",
    "IAB2-22": "Voitures anciennes",
    "IAB2-23": "Break",
    "IAB2-3": "Achat/Vente de voitures",
    "IAB2-4": "Culture automobile",
    "IAB2-5": "Occasion certifiée",
    "IAB2-6": "Cabriolet",
    "IAB2-7": "Coupé",
    "IAB2-8": "Crossover",
    "IAB2-9": "Diesel",
    "IAB20": "Voyage",
    "IAB20-1": "Voyage d'aventure",
    "IAB20-10": "Canada",
    "IAB20-11": "Caraïbes",
    "IAB20-12": "Croisières",
    "IAB20-13": "Europe de l'Est",
    "IAB20-14": "Europe",
    "IAB20-15": "France",
    "IAB20-16": "Grèce",
    "IAB20-17": "Lunes de miel/Escapades",
    "IAB20-18": "Hôtels",
    "IAB20-19": "Italie",
    "IAB20-2": "Afrique",
    "IAB20-20": "Japon",
    "IAB20-21": "Mexique & Amérique centrale",
    "IAB20-22": "Parcs nationaux",
    "IAB20-23": "Amérique du Sud",
    "IAB20-24": "Spas",
    "IAB20-25": "Parcs d'attractions",
    "IAB20-26": "Voyager avec des enfants",
    "IAB20-27": "Royaume-Uni",
    "IAB20-3": "Voyage aérien",
    "IAB20-4": "Australie & Nouvelle-Zélande",
    "IAB20-5": "Chambres d'hôtes",
    "IAB20-6": "Voyage économique",
    "IAB20-7": "Voyage d'affaires",
    "IAB20-8": "Par région US",
    "IAB20-9": "Camping",
    "IAB21": "Immobilier",
    "IAB21-1": "Appartements",
    "IAB21-2": "Architectes",
    "IAB21-3": "Achat/Vente de maisons",
    "IAB22": "Shopping",
    "IAB22-1": "Concours & Cadeaux",
    "IAB22-2": "Coupons",
    "IAB22-3": "Comparaison",
    "IAB22-4": "Moteurs",
    "IAB23": "Religion & Spiritualité",
    "IAB23-1": "Religions alternatives",
    "IAB23-10": "Païen/Wicca",
    "IAB23-2": "Athéisme/Agnosticisme",
    "IAB23-3": "Bouddhisme",
    "IAB23-4": "Catholicisme",
    "IAB23-5": "Christianisme",
    "IAB23-6": "Hindouisme",
    "IAB23-7": "Islam",
    "IAB23-8": "Judaïsme",
    "IAB23-9": "Mormons",
    "IAB24": "Non catégorisé",
    "IAB25": "Contenu non standard",
    "IAB25-1": "UGC non modéré",
    "IAB25-2": "Violence graphique/explicite extrême",
    "IAB25-3": "Pornographie",
    "IAB25-4": "Contenu vulgaire",
    "IAB25-5": "Contenu haineux",
    "IAB25-6": "En construction",
    "IAB25-7": "Incité",
    "IAB26": "Contenu illégal",
    "IAB26-1": "Contenu illégal",
    "IAB26-2": "Warez",
    "IAB26-3": "Logiciels espions/malveillants",
    "IAB26-4": "Violation des droits d'auteur",
    "IAB3": "Business",
    "IAB3-1": "Publicité",
    "IAB3-10": "Logistique",
    "IAB3-11": "Marketing",
    "IAB3-12": "Métaux",
    "IAB3-2": "Agriculture",
    "IAB3-3": "Biotechnologie/Biomédical",
    "IAB3-4": "Logiciels d'entreprise",
    "IAB3-5": "Construction",
    "IAB3-6": "Foresterie",
    "IAB3-7": "Gouvernement",
    "IAB3-8": "Solutions vertes",
    "IAB3-9": "Ressources humaines",
    "IAB4": "Carrières",
    "IAB4-1": "Planification de carrière",
    "IAB4-10": "Armée américaine",
    "IAB4-11": "Conseil carrière",
    "IAB4-2": "Université",
    "IAB4-3": "Aide financière",
    "IAB4-4": "Salons de l'emploi",
    "IAB4-5": "Recherche d'emploi",
    "IAB4-6": "Rédaction/Conseil CV",
    "IAB4-7": "Soins infirmiers",
    "IAB4-8": "Bourses",
    "IAB4-9": "Télétravail",
    "IAB5": "Éducation",
    "IAB5-1": "Éducation secondaire",
    "IAB5-10": "École à la maison",
    "IAB5-11": "Conseils devoirs/études",
    "IAB5-12": "Enseignants primaire",
    "IAB5-13": "École privée",
    "IAB5-14": "Éducation spécialisée",
    "IAB5-15": "Études commerciales",
    "IAB5-2": "Formation continue",
    "IAB5-3": "Histoire de l'art",
    "IAB5-4": "Administration universitaire",
    "IAB5-5": "Vie étudiante",
    "IAB5-6": "Formation à distance",
    "IAB5-7": "Français langue étrangère",
    "IAB5-8": "Apprentissage des langues",
    "IAB5-9": "École supérieure",
    "IAB6": "Famille & Parentalité",
    "IAB6-1": "Adoption",
    "IAB6-2": "Bébés & Tout-petits",
    "IAB6-3": "Garderie/Maternelle",
    "IAB6-4": "Internet familial",
    "IAB6-5": "Parentalité - Enfants",
    "IAB6-6": "Parentalité ados",
    "IAB6-7": "Grossesse",
    "IAB6-8": "Enfants à besoins spéciaux",
    "IAB6-9": "Soins aux aînés",
    "IAB7": "Santé & Forme",
    "IAB7-1": "Exercice",
    "IAB7-10": "Tumeur cérébrale",
    "IAB7-11": "Cancer",
    "IAB7-12": "Cholestérol",
    "IAB7-13": "Syndrome de fatigue chronique",
    "IAB7-14": "Douleur chronique",
    "IAB7-15": "Rhume & Grippe",
    "IAB7-16": "Surdité",
    "IAB7-17": "Soins dentaires",
    "IAB7-18": "Dépression",
    "IAB7-19": "Dermatologie",
    "IAB7-2": "T.D.A.H.",
    "IAB7-20": "Diabète",
    "IAB7-21": "Épilepsie",
    "IAB7-22": "RGO/Reflux acide",
    "IAB7-23": "Maux de tête/Migraines",
    "IAB7-24": "Maladie cardiaque",
    "IAB7-25": "Herbes médicinales",
    "IAB7-26": "Médecine holistique",
    "IAB7-27": "SCI/Maladie de Crohn",
    "IAB7-28": "Soutien inceste/abus",
    "IAB7-29": "Incontinence",
    "IAB7-3": "SIDA/VIH",
    "IAB7-30": "Infertilité",
    "IAB7-31": "Santé masculine",
    "IAB7-32": "Nutrition",
    "IAB7-33": "Orthopédie",
    "IAB7-34": "Troubles panique/anxiété",
    "IAB7-35": "Pédiatrie",
    "IAB7-36": "Physiothérapie",
    "IAB7-37": "Psychologie/Psychiatrie",
    "IAB7-38": "Santé des seniors",
    "IAB7-39": "Sexualité",
    "IAB7-4": "Allergies",
    "IAB7-40": "Troubles du sommeil",
    "IAB7-41": "Arrêt du tabac",
    "IAB7-42": "Toxicomanie",
    "IAB7-43": "Maladie thyroïdienne",
    "IAB7-44": "Perte de poids",
    "IAB7-45": "Santé féminine",
    "IAB7-5": "Médecine alternative",
    "IAB7-6": "Arthrite",
    "IAB7-7": "Asthme",
    "IAB7-8": "Autisme/TED",
    "IAB7-9": "Trouble bipolaire",
    "IAB8": "Alimentation & Boissons",
    "IAB8-1": "Cuisine américaine",
    "IAB8-10": "Allergies alimentaires",
    "IAB8-11": "Cuisine française",
    "IAB8-12": "Cuisine santé/allégée",
    "IAB8-13": "Cuisine italienne",
    "IAB8-14": "Cuisine japonaise",
    "IAB8-15": "Cuisine mexicaine",
    "IAB8-16": "Végétalien",
    "IAB8-17": "Végétarien",
    "IAB8-18": "Vin",
    "IAB8-2": "Barbecue & Grillades",
    "IAB8-3": "Cuisine cajun/créole",
    "IAB8-4": "Cuisine chinoise",
    "IAB8-5": "Cocktails/Bière",
    "IAB8-6": "Café/Thé",
    "IAB8-7": "Cuisine spécifique",
    "IAB8-8": "Desserts & Pâtisserie",
    "IAB8-9": "Restaurants",
    "IAB9": "Loisirs & Centres d'intérêt",
    "IAB9-1": "Art/Technologie",
    "IAB9-10": "Collection",
    "IAB9-11": "Bandes dessinées",
    "IAB9-12": "Dessin/Croquis",
    "IAB9-13": "Rédaction freelance",
    "IAB9-14": "Généalogie",
    "IAB9-15": "Se faire publier",
    "IAB9-16": "Guitare",
    "IAB9-17": "Enregistrement maison",
    "IAB9-18": "Investisseurs & Brevets",
    "IAB9-19": "Création de bijoux",
    "IAB9-2": "Arts & Artisanat",
    "IAB9-20": "Magie & Illusion",
    "IAB9-21": "Travaux d'aiguille",
    "IAB9-22": "Peinture",
    "IAB9-23": "Photographie",
    "IAB9-24": "Radio",
    "IAB9-25": "Jeux de rôle",
    "IAB9-26": "Science-fiction & Fantaisie",
    "IAB9-27": "Scrapbooking",
    "IAB9-28": "Scénario",
    "IAB9-29": "Timbres & Pièces",
    "IAB9-3": "Perlage",
    "IAB9-30": "Jeux vidéo & informatiques",
    "IAB9-31": "Travail du bois",
    "IAB9-4": "Observation des oiseaux",
    "IAB9-5": "Jeux de société/Puzzles",
    "IAB9-6": "Fabrication bougies & savons",
    "IAB9-7": "Jeux de cartes",
    "IAB9-8": "Échecs",
    "IAB9-9": "Cigares"
  },
  "layout": {
    "logout": "Déconnexion",
    "navigation": {
      "open": "Ouvrir la navigation"
    },
    "notifications": "Notifications",
    "profile": "Mon profil",
    "company": "Mon entreprise",
    "theme": {
      "label": "Thème",
      "light": "Clair",
      "dark": "Sombre",
      "system": "Système"
    },
    "documentation": "Documentation",
    "feed": "Flux",
    "hideArchived": "Masquer les archivés",
    "showArchived": "Afficher les archivés",
    "seeCompany": "Voir l'entreprise",
    "sidebar": {
      "close": "Fermer le menu",
      "documentation": "Documentation",
      "feed": "Flux",
      "hideArchived": "Cacher les archivés",
      "open": "Ouvrir le menu",
      "showArchived": "Afficher les archivés",
      "seeCompany": "Aller à la page de l'entreprise",
      "advertiser": {
        "createAdgroup": "Créer un adgroup",
        "createCampaign": "Créer une campagne",
        "title": "Campagnes et AdGroups"
      },
      "publisher": {
        "createPosition": "Créer une position",
        "createWebsite": "Créer un site",
        "title": "Sites et Positions"
      }
    },
    "newFrontVersion": {
      "title": "Bienvenue dans la nouvelle version de Powerspace",
      "oldUrlWarning": "Vous arrivez ici car vous avez sans doute utilisé un marque-page de l'ancienne version. Vous devez enregistrer à nouveau votre marque-page depuis cette nouvelle version.",
      "loginNewVersion": "Découvrir la nouvelle version"
    }
  },
  "login": {
    "errors": {
      "credentialsError": "Erreur de récupération des données pour le login: ",
      "invalidEmail": "Email invalide"
    },
    "form": {
      "continue": "Continuer",
      "orSeparator": "Ou",
      "passwordRecovery": "Mot de passe oublié ?",
      "rememberMe": "Se souvenir de moi"
    },
    "title": "Bienvenue"
  },
  "position": {
    "create": {
      "passbackStep": "Passback",
      "successMessage": "La position a bien été créée",
      "title": "Créer une nouvelle position",
      "websiteStep": {
        "title": "Site de la position",
        "websiteId": "Sélectionnez le website de la nouvelle position"
      }
    },
    "goToPosition": "Aller à {{positionName}}",
    "created": "Nouvelle position créée !",
    "updated": "Votre position à été mise à jour !",
    "preview": {
      "eyebrow": "Aperçu indisponible",
      "noActiveTemplate": "Aperçu impossible : aucun template actif",
      "inactive": "Aperçu impossible : la position est inactive",
      "archived": "Aperçu impossible : la position est archivée"
    },
    "settings": {
      "adPreview": "Aperçu",
      "addTag": {
        "noAdTemplate": "Aucun template actif",
        "noZoneWarning": "Au moins 1 zone est requise pour afficher les informations Ad tag",
        "bottomMessage": {
          "email": "Il s'agit du code de la position à placer dans le HTML de votre newsletter. Il est composé d'une URL d'image et d'une URL de clic pour chaque annonce (zone). Les valeurs entre \"$\" doivent être remplacées par les bonnes informations (ne gardez pas le \"$\").",
          "web": "Les valeurs entre \"{}\" doivent être remplacées par les bonnes informations (ne gardez pas le \"{}\")."
        },
        "copyButton": {
          "copied": "Copié",
          "copy": "Copier",
          "copyAll": "Copier tout"
        },
        "optionSwitches": {
          "age": "Age",
          "clearEmail": "Email en clair",
          "gender": "Genre",
          "md5Email": "Email MD5",
          "sha256Email": "Email SHA256",
          "location": "Localisation",
          "tooltip": {
            "md5Email": "Email hashé avec l'algorithme MD5",
            "sha256Email": "Email hashé avec l'algorithme SHA256",
            "gender": "Genre — Format : M/F ou H/F",
            "age": "Date de naissance — Format : ISO 8601 (AAAA-MM-JJ)",
            "location": "Localisation — ps_z (code postal) et ps_c (code pays) — Format : code postal numérique et code pays ISO 3166-1 alpha-2 (ex: 75001, FR)"
          }
        },
        "tagCode": {
          "endPageScriptMessage": "Il s'agit du code de la position à placer dans le HTML de votre newsletter. Il est composé d'une URL d'image et d'une URL de clic pour chaque annonce (zone). Les valeurs entre \"$\" doivent être remplacées par les bonnes informations (ne gardez pas le \"$\")."
        },
        "title": "Ad tag",
        "topLeft": {
          "customDomain": "Domaine personnalisé",
          "customDomainStatusInProgress": "Création du certificat SSL en cours",
          "customDomainStatusInvalid": "Le certificat SSL est invalide. Demandez plus de détails à Powerspace.",
          "customDomainStatusInvalidWithFailure": "Le certificat SSL est invalide : {{failureReason}}",
          "customDomainStatusValid": "Le certificat SSL est valide",
          "customDomainStatusTooltip": "SSL: {{sslStatus}}",
          "customDomainStatusTooltipWithFailure": "SSL: {{sslStatus}} - Raison de l'échec : {{failureReason}}",
          "customDomainInvalidStatus": "La configuration du domaine personnalisé n'est pas encore valide",
          "webCSS": "Template CSS",
          "webHTML": "HTML",
          "webIframe": "Iframe"
        },
        "zone": "Zone",
        "adTemplateSelection": "Selection du template",
        "atLeastBannerOrNative": "Au moins une template banner ou native doit être sélectionnée",
        "noAdTemplateWithThisFormat": "Pas de template pour ce format",
        "integrationCode": "Code d'intégration",
        "addZone": "Ajouter une zone",
        "removeZone": "Supprimer la zone"
      },
      "demandSource": {
        "editTitle": "Éditer les sources de demande",
        "title": "Sources de demande"
      },
      "passBack": {
        "editTitle": "Éditer le paramètre PassBack",
        "passbackImage": "Image PassBack",
        "passbackLink": "Lien PassBack",
        "title": "Paramètre PassBack"
      },
      "summary": {
        "acceptGif": "Accepter Gif",
        "biddingStrategy": "Stratégie d'enchère",
        "cpmFloor": "CPM plancher",
        "editTitle": "Editer les paramètres de la position",
        "externalRevenueShare": "Revenue share externe",
        "integrationType": "Type d'intégration",
        "nbZone": "Nombre de zones",
        "revenueShare": "Revenue share",
        "title": "Résumé des paramètres de la position",
        "shortCode": "Code court"
      }
    },
    "summary": {
      "channelType": "Type de canal",
      "editTitle": "Éditer la position",
      "network": "Réseau",
      "positionType": "Type",
      "subchannelType": "Placement",
      "status": "Statut",
      "title": "Résumé de la position"
    }
  },
  "search": {
    "adgroup": {
      "allFilter": "Tous les AdGroups"
    },
    "allIAB": "Tous les IAB",
    "campaign": {
      "allFilter": "Toutes les campagnes"
    },
    "defaultAllFilter": "Tous",
    "globalSearch": "Recherche globale",
    "position": {
      "channelType": "Canal",
      "companyName": "Compagnie",
      "id": "ID",
      "status": "Statut",
      "marketCode": "Marché",
      "nameWithWebsite": "Nom de la position",
      "network": "Réseau",
      "resellerName": "Revendeur",
      "subchannelType": "Placement"
    },
    "resetFilters": "Réinitialiser les filtres",
    "user": {
      "selectCompany": "Sélectionnez l'entreprise du nouvel utilisateur",
      "allFilter": "Tous les utilisateurs"
    },
    "website": {
      "allFilter": "Tous les Sites"
    }
  },
  "website": {
    "create": "Créer un nouveau site",
    "created": "Site créé !",
    "name": "Nom du site",
    "url": "URL du site",
    "category": "Catégorie",
    "market": "Marché",
    "details": {
      "companyId": "Compagnie",
      "iabCodeAndCategory": "Catégorie IAB",
      "market": "Marché",
      "positions": "Positions",
      "publisherId": "Compagnie",
      "publisherName": "Compagnie",
      "resellerName": "Revendeur",
      "stepperTitle": "Détails du site",
      "publisherStepTitle": "Éditeur",
      "url": "URL"
    },
    "edit": {
      "sectionTitle": "Modifier le site"
    },
    "updated": "Votre site a été mis à jour !",
    "goToWebsite": "Aller à {{websiteName}}",
    "positionsHelper": "Ajoutez éventuellement des positions au nouveau site. Vous pouvez en ajouter plusieurs avant de terminer la création.",
    "sectionTitle": "Résumé du site",
    "statusWarning": "Le site {{name}} est inactif.",
    "tabs": {
      "dashboard": "Tableau de bord",
      "blacklist": "Liste noire"
    }
  },
  "stats": {
    "title": "Stats",
    "statsPerCampaignFor": "Statistiques par campagne {{iab}}",
    "globalStatsFor": "Statistiques globales {{iab}}",
    "top10AdGroupsFor": "Top 10 des adgroups {{iab}}",
    "common": {
      "invalidReason": {
        "title": "Raison",
        "CAMPAIGN_NOT_MATCHING": "La campagne fournie en paramètre du lead ou de la commande ne correspond pas à la campagne {{campaignId}}",
        "ALIAS": "Le lead ou la commande a déjà été effectué pour ce clic",
        "OLD_CLICK": "Le clic a expiré",
        "UNDEFINED_WON_BID": "Aucun clic n'a été trouvé pour le lead ou la commande",
        "TEST": "Test",
        "NO_CLICK_FOUND": "Aucun clic n'a été trouvé pour le lead ou la commande",
        "UNDEFINED_POSITION": "Aucune position correspondant au clic n'a été trouvée pour le lead ou la commande",
        "BLACKLISTED": "L'utilisateur a été blacklisté",
        "EMAIL_BLACKLISTED": "L'email est blacklisté",
        "BLACKLISTED_PROFILE": "L'utilisateur est blacklisté"
      }
    },
    "maxDetailsMessage": "Vous ne pouvez pas afficher les stats détaillées pour plus de {{maxMonths}} mois.",
    "chart": {
      "close": "Fermer le graphique",
      "showFullscreen": "Afficher le graphique",
      "title": "Graphique"
    },
    "filter": {
      "datesRange": "Dates",
      "Channel": "Canal",
      "Market": "Marché",
      "Network": "Réseau",
      "DemandSource": "Sources de demande",
      "granularity": "Granularité",
      "timeframe": "Période",
      "dataTypes": "Type de données",
      "kpi": "KPI",
      "timeframeValues": {
        "today": "Aujourd'hui",
        "yesterday": "Hier",
        "thisDayLastWeek": "Ce jour la semaine dernière",
        "last3Days": "3 derniers jours",
        "last30Days": "30 derniers jours",
        "last60Days": "60 derniers jours",
        "thisMonth": "Ce mois",
        "lastMonth": "Le mois dernier",
        "thisQuarter": "Ce trimestre",
        "lastQuarter": "Le trimestre dernier",
        "last3Month": "3 derniers mois",
        "thisWeek": "Cette semaine",
        "lastWeek": "La semaine dernière",
        "thisYear": "Cette année",
        "lastYear": "L'année dernière",
        "custom": "personnalisé"
      },
      "kpiSelection_one": "1 KPI sélectionné",
      "kpiSelection_other": "{{count}} KPI sélectionnés",
      "displayValues": "Afficher les valeurs",
      "kpiSelection_many": "{{count}} KPI sélectionnés"
    },
    "table": {
      "date": "Date",
      "commissions": "Commissions",
      "rpm": "RPM",
      "displays": "Affichages",
      "channelType": "Canal",
      "lr": "LR",
      "or": "OR",
      "dailyBudget": "Budget journalier"
    },
    "customDisplay": {
      "publisher": {
        "displays": "Affichages",
        "commissions": "Commissions",
        "cpc": "CPC",
        "rpm": "RPM",
        "lr": "LR",
        "or": "OR",
        "impression": "Impressions & Affichages",
        "userEvent": "Clics",
        "costRatio": "CTR",
        "costStats": "RPM & CPM & CPC"
      },
      "advertiser": {
        "impression": "Impressions",
        "cpc": "CPC",
        "cpl": "CPL",
        "cpo": "CPO",
        "rpm": "RPM",
        "lr": "LR",
        "or": "OR",
        "userEvent": "Clics",
        "costRatio": "CTR",
        "costStats": "CPM & CPC",
        "costs": "Coûts",
        "roi": "ROI",
        "adGroups": "AdGroups",
        "campaigns": "Campagnes",
        "analytics": "Analytics"
      }
    },
    "dataTypes": {
      "devices": "Appareils",
      "timeseries": "Séries temporelles",
      "campaigns": "Campagnes",
      "positions": "Positions",
      "resellers": "Sources de demande",
      "adTemplates": "Modèles",
      "websitesAndPositions": "Sites et positions",
      "advertisers": "Annonceurs",
      "adcopies": "Créatives",
      "adgroups": "AdGroups",
      "publishers": "Publishers",
      "zones": "Zones"
    },
    "powerspace": {
      "budgets": {
        "revenue": "Revenue",
        "dailyBudget": "Budget journalier",
        "campaigns": "Campagnes",
        "adGroups": "AdGroups",
        "cpc": "CPC",
        "cpm": "CPM"
      }
    },
    "granularity": {
      "Hour": "par heure",
      "Day": "par jour",
      "Week": "par semaine",
      "Month": "par mois",
      "Year": "par an"
    }
  },
  "advertiser": {
    "settings": {
      "gestion": "Mode de gestion de l'annonceur",
      "subType": "Type d'annonceur",
      "unknownTrafficRate": "Taux de fraude autorisé",
      "unknownTrafficRateDescription": "Le taux de traffic inconnu autorisé est le pourcentage maximum de clics ou de leads que l'on peut considérer comme valides vennant de sources inconnues.",
      "copperCompany": "Entreprise Copper",
      "unlinkCopperCompany": "Retirer le lien avec l'entreprise Copper",
      "unlinkAgency": "Retirer le lien avec l'agence"
    }
  },
  "agency": {
    "settings": {
      "copperCompany": "Entreprise Copper",
      "unlinkCopperCompany": "Retirer le lien avec l'entreprise Copper"
    }
  },
  "tradingDesk": {
    "sectionTitle": "Trading desk",
    "settings": {
      "seats": "Seats",
      "dsp": "dsp",
      "seat": "seat"
    }
  },
  "programmaticCampaign": {
    "sectionTitle": "Campagne programmatique",
    "statusWarning": "La campagne programmatique {{name}} est stoppée."
  },
  "report": {
    "autoReload": {
      "5m": "5 minutes",
      "10m": "10 minutes",
      "20m": "20 minutes",
      "30m": "30 minutes"
    }
  },
  "activity": {
    "autoReload": {
      "30s": "30 secondes",
      "1m": "1 minute",
      "5m": "5 minutes",
      "pageOneOnly": "Le rechargement auto n'est actif que sur la page 1"
    },
    "refresh": "Actualiser",
    "todayTitle": "Aujourd'hui ({{date}})",
    "yesterdayTitle": "Hier ({{date}})",
    "earlierTitle": "Plus tôt",
    "feed": {
      "userNotFound": "Utilisateur inconnu",
      "propertyOfEntity": "propriété {{property}} de",
      "fromOldValueToNewValue": "de {{oldValue}} à {{newValue}}",
      "oldToNew": "{{oldValue}} → {{newValue}}",
      "changed": "Changé",
      "seeAllChanges": "Tout voir",
      "showAllChanges": "Afficher tous les changements",
      "showLimitedChanges": "Afficher moins de changements",
      "status": "status",
      "of": "de",
      "from": "de",
      "fromRestrictionListOf": "de la liste de restriction de",
      "fromExclusionPresetOf": "du preset d'exclusion",
      "to": "à",
      "toRestrictionListOf": "à la liste de restriction de",
      "toExclusionPresetOf": "au preset d'exclusion",
      "created": "Créé",
      "updated": "Modifié",
      "invited": "Invité",
      "withId": "avec l'id",
      "toJoinCompany": "a rejoindre {{companyName}}",
      "doneAutomaticallyByPlatform": "Effectué automatiquement par la plateforme",
      "platform": "Plateforme",
      "userPasswordUpdatedBeforeUser": "Le mot de passe de",
      "userPasswordUpdatedAfterUser": "a été modifié",
      "geoTargetingChanged": "Le ciblage géographique a été modifié",
      "adTemplateNativeContentUpdatedBeforeTemplate": "le contenu du template",
      "properties": {
        "acceptEditorial": "Accepter éditorial",
        "acceptGif": "Accepter GIF",
        "acceptPromotional": "Accepter promotionnel",
        "accessType": "Type d'accès",
        "accountingId": "Identifiant comptable",
        "accountManagerId": "Account manager",
        "active": "Actif",
        "addressLine1": "Adresse ligne 1",
        "adgroupDirectory": "Restriction de diffusion",
        "adjustment": "Ajustement",
        "advertiserName": "Nom de l'annonceur",
        "agencyId": "Agence",
        "ageRange": "Tranche d'âge",
        "archived": "Archivé",
        "autoSegments": "Auto-segments",
        "backgroundColor": "Couleur de fond",
        "bankName": "Nom de la banque",
        "biddingStrategy": "Stratégie d'enchère",
        "budget": "Budget",
        "budgetCapping": "Plafonnement budgétaire",
        "budgetCappingType": "Type de plafonnement budgétaire",
        "budgetPlan": "Changement de budget planifié",
        "callToAction": "Call to action",
        "channelEmail": "Email",
        "channelType": "Type de canal",
        "channelWeb": "Web",
        "cities": "Villes",
        "city": "Ville",
        "comments": "Commentaires",
        "company": "Entreprise",
        "campaign": "Campagne",
        "iabCategory": "Catégorie IAB",
        "contactEmail": "Email de contact",
        "content": "Contenu",
        "conversionClickAge": "Âge du clic de conversion",
        "cost": "Coût",
        "costModel": "Modèle de coût",
        "costType": "Type",
        "costValue": "Coût",
        "countries": "Pays",
        "countryBlacklistRedirectUrl": "URL de redirection liste noire pays",
        "countryId": "Pays",
        "cpc": "CPC",
        "cpm": "CPM",
        "cpmFloor": "CPM plancher",
        "css": "CSS",
        "cssSelector": "Sélecteur CSS",
        "cssSelectorPosition": "Position du sélecteur CSS",
        "currency": "Devise",
        "dailyBudget": "Budget journalier",
        "dailyBudgetType": "Type de budget journalier",
        "dayWeek": "Jour de la semaine",
        "dealId": "Deal ID",
        "defaultCpc": "CPC par défaut",
        "demandSources": "Sources de demande",
        "departements": "Départements",
        "description": "Description",
        "deviceExclusive": "Exclusif appareil",
        "deviceType": "Type d'appareil",
        "directoryPositionIds": "Positions du répertoire",
        "directoryPresetIds": "Presets de restriction de diffusion",
        "directoryWebsiteIds": "Sites web du répertoire",
        "email": "Email",
        "endDate": "Date de fin",
        "externalRevenueShare": "Revenue share externe",
        "fax": "Fax",
        "firstName": "Prénom",
        "forceRedirectUrl": "URL de redirection",
        "format": "Format",
        "gender": "Genre",
        "genericName": "Nom générique",
        "geoExclusive": "Exclusif géographique",
        "geoTargeting": "Ciblage géographique",
        "geoTargetingType": "Type de ciblage géographique",
        "gestion": "Mode de gestion de l'annonceur",
        "hourDay": "Heure de la journée",
        "iban": "IBAN",
        "image": "Image",
        "integrationType": "Type d'intégration",
        "invoicingCompany": "Entité de facturation",
        "isActive": "Actif",
        "isArchived": "Archivé",
        "js": "JavaScript",
        "kpis": "KPIs",
        "label": "Libellé",
        "landline": "Téléphone fixe",
        "language": "Langue",
        "lastName": "Nom",
        "market": "Marché",
        "marketId": "Marché",
        "masterTemplate": "Template master",
        "mobile": "Mobile",
        "name": "Nom",
        "nbZone": "Nombre de zones",
        "network": "Réseau",
        "networkExtensions": "Extensions réseau",
        "numberCampaignExclusions": "Exclusions de campagnes",
        "numberCustomCosts": "Coûts personnalisés",
        "numberWebsiteExclusions": "Exclusions de sites web",
        "osExclusive": "Exclusif OS",
        "os": "OS",
        "osType": "Type d'OS",
        "passbackImage": "Image PassBack",
        "passbackJs": "Passback JS",
        "passbackLink": "Lien PassBack",
        "password": "Mot de passe",
        "paymentTerm": "Conditions de paiement",
        "permissions": {
          "api": "API",
          "web": "Canal web",
          "banner": "Canal bannière",
          "adgroupCpm": "Coût CPM",
          "adgroupCpl": "Coût CPL",
          "adgroupExclusions": "Restriction de diffusion",
          "adgroupCustomcpcs": "Ajustements d'enchères",
          "adgroupReportwebsites": "Rapport par site web",
          "adgroupUsertargeting": "Ciblage démographique",
          "adgroupGeotargeting": "Ciblage géographique",
          "adgroupDevicetargeting": "Ciblage appareil",
          "adgroupTimetargeting": "Ciblage heure et jour",
          "adgroupSegments": "Segments CRM",
          "adgroupAutoSegments": "Auto-segments",
          "adgroupPriority": "Priorité adgroup",
          "adgroupMonthlyBudgetCapping": "Plafond mensuel",
          "adgroupOverallBudgetCapping": "Plafond global",
          "adgroupOpenBudgetCapping": "Plafond ouvert",
          "adgroupOpenDailyBudget": "Budget journalier ouvert",
          "adCopyDates": "Dates créative",
          "positionAdvancedsettings": "Paramètres avancés position",
          "websiteExclusions": "Exclusions campagne site web",
          "advertiserDirectoryPresets": "Presets de restriction de diffusion",
          "publisherBlacklistPresets": "Presets de liste noire"
        },
        "phone": "Téléphone",
        "positionIds": "Position",
        "positionType": "Type de position",
        "priorityId": "Priorité",
        "profileTagIds": "Tags profil",
        "rawGeoTargeting": "Ciblage géographique",
        "redirectUrl": "URL de redirection",
        "regions": "Régions",
        "registrationId": "Identifiant d'enregistrement",
        "revenueShare": "Revenue share",
        "role": "Rôle",
        "rootDomain": "Domaine racine",
        "rules": "Règles",
        "salesManagerId": "Sales manager",
        "secret": "Secret",
        "segmentIds": "Segments",
        "slackId": "Slack ID",
        "slug": "Sous-domaine de l'entreprise",
        "sspId": "SSP ID",
        "startDate": "Date de début",
        "status": "Statut",
        "subchannelType": "Placement",
        "subType": "Sous-type",
        "swift": "SWIFT / BIC",
        "tags": "Tags",
        "targetUnknownAge": "Âge inconnu",
        "taxId": "Identifiant fiscal",
        "template": "Template",
        "title": "Titre",
        "unknownTrafficRate": "taux de fraude autorisé",
        "url": "URL",
        "userCappingTimeframe": "Période de capping utilisateur",
        "userCappingType": "Type de capping utilisateur",
        "userCappingValue": "Valeur de capping utilisateur",
        "vatId": "Numéro de TVA",
        "website": "Site web",
        "websiteIds": "Site web",
        "websiteName": "Nom du site web",
        "weight": "Poids",
        "zipCode": "Code postal",
        "zones": "Zones",
        "zoneTemplate": "Template zone"
      },
      "deleted": "Supprimé",
      "added": "Ajouté",
      "removed": "Retiré",
      "addedOnZoneTheTemplate": "sur la zone {{zone}} le template",
      "removedFromZoneTheTemplate": "de la zone {{zone}} le template",
      "valueToPropertyOfEntity": "{{value}} à la propriété {{property}} de",
      "valueFromPropertyOfEntity": "{{value}} de la propriété {{property}} de"
    }
  },
  "serverError": {
    "Wrong credentials": "Adresse email ou mot de passe incorect.",
    "ONLY_ADTEMPLATE_ERROR": "Vous n'êtes pas autorisé à désactiver la seule template active"
  },
  "templateEditor": {
    "createMobileVersion": "Etes vous sur de vouloir créer une version mobile de cette Ad Template?",
    "control": {
      "addElement": "Ajouter un élément",
      "addShape": "Ajouter {{name}}",
      "addPlaceholderCustomText": "Ajouter le texte '{{name}}'",
      "addImage": "Ajouter un placeholder d'image au ratio {{ratio}}",
      "backgroundColor": "Couleur de fond",
      "background": "Arrière-plan",
      "borderRadius": "Angle",
      "changeBackgroundColor": "Changer la couleur de fond",
      "fontWeight": "Gras",
      "font": "Police",
      "fontStyle": "Italic",
      "underline": "Sousligné",
      "upperCase": "Lettre en majuscule",
      "width": "Largeur",
      "height": "Hauteur",
      "fontSize": "Taille",
      "textColor": "Couleur du texte",
      "left": "Depuis le haut",
      "top": "Depuis la gauche",
      "transparentBackground": "Fond transparent",
      "text": "Texte",
      "imageplaceholder": "Placeholder d'image",
      "imageSizeLimit": "L'image dépasse les dimensions maximales, elle sera redimensionnée pour s'adapter à {{width}}x{{height}}.",
      "moveForward": "Avancer en avant",
      "moveBackward": "Envoyer vers l'arrière",
      "align": {
        "left": "Aligner à gauche",
        "center": "Aligner au centre",
        "right": "Aligner à droite",
        "top": "Aligner en haut",
        "middle": "Aligner au milieu",
        "bottom": "Aligner en bas"
      },
      "templateBackgroundColor": "Couleur de fond",
      "templateBackgroundImage": "Choisir une image de fond",
      "newText": "Nouveau texte",
      "placeholderAlreadyExists": "Le placeholder {{placeholder}} existe déjà dans le template",
      "imageAlreadyExists": "Une image existe déjà dans le template",
      "removeBackground": "Supprimer l'image de fond",
      "settings": "Paramètres du template",
      "stroke": "Couleur de bordure",
      "strokeWidth": "Largeur de bordure",
      "shape": "Forme",
      "zoom": "Zoom"
    },
    "oneImageMax": "Une seule image est autorisée dans le template",
    "duplicatedPlaceholder": "Les placeholders doivent être uniques",
    "title": "Éditeur de template",
    "preview": {
      "title": "Aperçu du template"
    },
    "unsavedChanged": "Il y a des changements non sauvegardés. Êtes-vous sûr de vouloir afficher le template {{versionType}} ? Tout changement non sauvegardé sera perdu.",
    "versionType": {
      "main": "Version principale",
      "mobile": "Version mobile"
    },
    "importTemplate": "Importer un template",
    "importTemplateSuccess": "Le template a été importé !",
    "chooseTemplate": "Choisissez un template",
    "imageSizeWarning": "Pour un centrage correct, la taille de l'image doit correspondre à la taille du template affiché ci-dessus. Vous pouvez toujours enregistrer l'image, mais le centrage peut être incorrect.",
    "imageOutOfTemplate": "L'image principale de ce template comporte des parties en dehors du template, ce qui peut entraîner des publicités mal coupées et un CTR plus faible.",
    "canvasSizeWarning": "Les images d'une largeur inférieure à 400px peuvent être pixelisées, pour afficher correctement un petit template, augmentez la largeur de celui-ci et fixez la taille dans votre CSS."
  },
  "table": {
    "columns": "Colonnes",
    "comparisonFilter": {
      "after": "Après",
      "before": "Avant",
      "between": "Entre",
      "end": "Fin",
      "lessThan": "Inférieur à",
      "lessThanOrEqual": "Inférieur ou égal à",
      "moreThan": "Supérieur à",
      "moreThanOrEqual": "Supérieur ou égal à",
      "operator": "Filtre de date",
      "start": "Début"
    },
    "emptyValues": "Valeurs vides",
    "filterValue": "Valeur du filtre",
    "nonEmptyValues": "Valeurs non vides"
  },
  "resetPassword": {
    "login": "Se connecter",
    "enterNewPassword": "Veuillez entrer votre nouveau mot de passe",
    "emailSentMessage": "Un e-mail a été envoyé à <strong>{{email}}</strong>. Veuillez cliquer sur le lien à l'intérieur pour créer un nouveau mot de passe. Si vous ne recevez pas cet e-mail, veuillez vérifier vos spams.",
    "newPassword": "Nouveau mot de passe",
    "resetSuccess": "Votre mot de passe a été réinitialisé avec succès. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe",
    "requestInstruction": "Veuillez saisir votre adresse e-mail ci-dessous et vous recevrez des instructions pour réinitialiser votre mot de passe.",
    "returnToLogin": "Retour à la page de connexion",
    "requestResetPassword": "Réinitialiser le mot de passe",
    "resetPasswordSubmit": "Réinitialiser le mot de passe",
    "title": "Mot de passe oublié ?",
    "serverError": {
      "tokenExpired": "Désolé, ce lien de réinitialisation de mot de passe a expiré. Veuillez demander un nouveau lien de réinitialisation de mot de passe et réessayer."
    }
  },
  "invitation": {
    "AcceptInvitation": "Accepter l'invitation",
    "title": "Création de compte",
    "contactDetails": "vos coordonnées",
    "password": "Mot de passe",
    "acceptInviteSuccess": "Votre compte a été créé avec succès. Vous pouvez maintenant vous connecter avec votre adresse email et votre mot de passe",
    "goToLogin": "Aller à la page de connexion",
    "serverError": {
      "invalidToken": "Désolé, ce lien d'invitation n'est pas valide. Veuillez demander un nouveau lien d'invitation et réessayer."
    },
    "acceptInvitation": "Accepter l'invitation"
  },
  "ErrorBoundaryUIFallback": {
    "eyebrow": "Oups !",
    "somethingWentWrong": "Un imprévu s'est produit.",
    "apologizeInconvenience": "Désolé pour la gêne occasionnée. Un rafraîchissement de la page suffit souvent.",
    "refreshPage": "Rafraîchir la page"
  },
  "NotFoundPage": {
    "eyebrow": "404",
    "title": "Cette page est introuvable.",
    "description": "Le lien est peut-être incorrect ou la page a été déplacée. Revenons sur de bons rails.",
    "backToHome": "Retour au tableau de bord",
    "backToLogin": "Retour à la connexion"
  },
  "adTest": {
    "settings": {
      "zoom": "Taille de l'aperçu"
    }
  },
  "simulation": {
    "title": "Simulation de reach",
    "description": "Configurez le marché, le réseau, le ciblage et éventuellement des presets de restriction de diffusion pour prévisualiser le reach estimé sans enregistrer.",
    "disclaimer": "Les modifications sur cette page ne sont pas enregistrées. Utilisez-la pour explorer l'impact sur le reach avant de mettre à jour un ad group.",
    "directory": {
      "title": "Restriction de diffusion"
    },
    "reach": {
      "info": "Cette estimation n'inclut pas le géociblage et les segments."
    },
    "errors": {
      "market": "Impossible de charger les marchés pour la simulation."
    }
  },
  "home": {
    "tabs": {
      "powerspace": "Powerspace",
      "activityfeed": "Flux d'activité",
      "adTest": "Aperçu",
      "reports": "Rapports",
      "companies": "Entreprises",
      "adgroups": "AdGroups",
      "websites": "Sites",
      "positions": "Positions",
      "users": "Utilisateurs"
    }
  },
  "impersonation": {
    "connectAs": "Se connecter en tant que {{firstName}} {{lastName}}",
    "confirm": "Voulez-vous vraiment vous connecter en tant que {{firstName}} {{lastName}} ?\nVotre navigation sera en lecture seule.",
    "banner": "Mode viewer : vous êtes connecté en tant que {{firstName}} {{lastName}} ({{email}}).",
    "quit": "Quitter l'impersonation",
    "errors": {
      "notAuthenticated": "Vous devez être connecté pour impersonner un utilisateur.",
      "startFailed": "Impossible de démarrer l'impersonation."
    }
  },
  "directoryPresets": {
    "createTitle": "Créer une liste de restriction",
    "editTitle": "Modifier la liste de restriction",
    "description": "Créez des presets de restriction de diffusion pour réutiliser les mêmes restrictions de sites et de positions dans vos ad groups.",
    "created": "Preset de restriction créé",
    "saved": "Preset de restriction enregistré",
    "deleted": "Preset de restriction supprimé",
    "deleteConfirm": "Supprimer la liste de restriction {{name}} ? Cette action la retire également de tous les ad groups qui l'ont sélectionnée.",
    "addTitle": "Ajouter des sites",
    "duplicateName": "Ce nom est déjà utilisé par une autre liste de restriction",
    "view": "Voir",
    "viewTitle": "Liste de restriction",
    "unassign": "Retirer"
  },
  "billing": {
    "actionButtons": {
      "download": "Télécharger",
      "edit": "Éditer",
      "validate": "Valider",
      "validateAll": "Valider les factures sélectionnées",
      "recordPayment": "Enregistrer le paiement",
      "downloadInvoices": "Télécharger les factures sélectionnées"
    },
    "editInvoice": {
      "comment": "Commentaire",
      "publisher": "Editeur",
      "billedTo": "Facturé à",
      "invoiceNb": "Facture n°",
      "payment": "Paiement",
      "description": "Description / commissions publicitaires",
      "updated": "La facture a été mise à jour",
      "totalExcludingTaxes": "Total (HT)",
      "totalIncludingTaxes": "Total (TTC)",
      "title": "Editer la facture",
      "vat": "TVA"
    },
    "confirmValidation": "Êtes-vous sûr de vouloir changer le statut de la (des) facture(s) en VALIDÉ ? Les contacts concernés seront notifiés et une copie de la (des) facture(s) sera partagée.",
    "invoicesAlreadyGenerated": "Toutes les factures pour cette période ont déjà été générées.",
    "downloadError": "Une erreur s'est produite lors du téléchargement de la facture. Veuillez réessayer ou contacter le support.",
    "downloadInvoice": "Télécharger la facture",
    "generateInvoices": "Générer les factures",
    "generatedSuccess": "Les factures ont été générées avec succès",
    "minAmount": "Montant minimum",
    "paidInvoice": {
      "title": "Enregistrer le paiement",
      "saved": "Le paiement a été enregistré",
      "paidWarning": "Êtes-vous sûr de vouloir changer le statut de la facture en PAYÉ ? Les contacts concernés seront notifiés et une copie de la facture sera partagée. La facture sera définitivement marquée comme payée et aucune autre modification ne sera possible."
    },
    "Paid": "Payé",
    "Pending": "En attente",
    "Validated": "Validé",
    "reference": "Référence",
    "period": "Période",
    "publisherName": "Éditeur",
    "advertiserName": "Annonceur",
    "amount": "Montant",
    "tax": "Taxe",
    "total": "Montant total",
    "date": "Date",
    "dueDate": "Date d'échéance",
    "previewInvoice": "Aperçu de la facture",
    "summary": "Résumé de la facture",
    "selectedCount_one": "{{count}} facture sélectionnée",
    "selectedCount_other": "{{count}} factures sélectionnées",
    "validated": "La facture a été validée"
  },
  "publisher": {
    "analyze": {
      "title": "Analyse",
      "privateStatsMessage": "Ces statistiques sont privées et ne sont visibles que par Powerspace. Ne les partagez pas avec vos clients.",
      "populationStats": {
        "title": "Population",
        "os": "OS",
        "deviceType": "Type d'appareil",
        "ageRange": "Tranche d'âge",
        "gender": "Genre"
      }
    },
    "blacklist": {
      "advertisers": "Annonceurs exclus",
      "advertisersDescription": "Bloquer la diffusion pour les annonceurs sélectionnés.",
      "campaigns": "Campagnes exclues",
      "campaignsDescription": "Bloquer la diffusion pour les campagnes sélectionnées.",
      "addAdvertisers": "Ajouter des annonceurs",
      "addCampaigns": "Ajouter des campagnes",
      "addDomains": "Ajouter des domaines",
      "addIabCategories": "Ajouter des catégories IAB",
      "newlyAddedAdvertisers": "annonceur(s) sélectionné(s)",
      "newlyAddedCampaigns": "campagne(s) sélectionnée(s)",
      "newlyAddedCategories": "iab(s) sélectionnée(s)",
      "domainSeparators": "Les domaines doivent être séparés par un espace ou une virgule",
      "domainPlaceholder": "Entrée ici le domain",
      "iab": "Catégories IAB exclues",
      "iabDescription": "Bloquer la diffusion sur les contenus correspondant aux catégories IAB sélectionnées.",
      "domains": "Domaines exclus",
      "domainsDescription": "Bloquer la diffusion sur les domaines annonceurs sélectionnés.",
      "publisherExclusionsTitle": "Exclusions publisher",
      "publisherExclusionsDescription": "Configurer les exclusions appliquées à ce publisher, y compris les presets assignés et les exclusions directes.",
      "resellerExclusionsTitle": "Exclusions reseller",
      "resellerExclusionsDescription": "Configurer les exclusions appliquées à ce reseller et héritées par ses publishers et sites web.",
      "websiteExclusionsTitle": "Exclusions du site web",
      "websiteExclusionsDescription": "Configurer les exclusions appliquées à ce site web, y compris les presets assignés et les exclusions directes.",
      "publisherExclusionListsTitle": "Preset d'exclusion publisher",
      "publisherExclusionListsDescription": "Créer et gérer des presets d'exclusion réutilisables pour ce publisher. Assignez-les depuis la section exclusions ci-dessous.",
      "resellerExclusionListsTitle": "Preset d'exclusion reseller",
      "resellerExclusionListsDescription": "Créer et gérer des presets d'exclusion réutilisables pour ce reseller. Ces presets sont disponibles pour tous les publishers et sites web de ce reseller. Assignez-les depuis la section exclusions ci-dessous.",
      "presets": {
        "title": "Listes d'exclusions",
        "assignDescription": "Appliquer des presets d'exclusion réutilisables à ce périmètre.",
        "name": "Nom du preset",
        "use": "Utiliser un preset",
        "createNew": "Créer un preset",
        "assigned": "Assigné",
        "unassign": "Retirer",
        "noAvailablePresets": "Aucun preset disponible à assigner.",
        "noOwnedPresets": "Aucun preset possédé.",
        "noAssignedPresets": "Aucun preset assigné.",
        "resellerAssignDescription": "Les presets assignés ici s'appliquent à tous les publishers et sites web de ce reseller.",
        "ownedTitle": "Presets possédés",
        "deleteConfirm": "Supprimer cette liste d'exclusions ?",
        "createTitle": "Créer une liste d'exclusions",
        "editTitle": "Modifier la liste d'exclusions",
        "loadError": "Échec du chargement de la liste d'exclusions.",
        "viewTitle": "Liste d'exclusions",
        "noExclusions": "Aucune exclusion dans cette catégorie.",
        "convertToPreset": "Convertir en preset",
        "convertToPresetTitle": "Convertir la blacklist en preset",
        "ownerCompany": "Société propriétaire",
        "replaceWithPresetConfirm": "Remplacer la blacklist actuelle par le preset {{name}} ?",
        "replaceWithPresetApplied": "Preset appliqué et blacklist effacée",
        "duplicateName": "Ce nom est déjà utilisé par un autre preset d'exclusion",
        "domainsPreservedOnConvert": "Les exclusions de domaines ne peuvent pas être stockées dans les presets et resteront sur cet objet.",
        "created": "Preset d'exclusion créé",
        "convertToPresetDisabledAssignedPreset": "Un preset est déjà assigné. Retirez les presets assignés avant de convertir la blacklist.",
        "convertToPresetDisabledEmpty": "Il n'y a aucune exclusion annonceur, campagne ou IAB à convertir."
      },
      "filters": {
        "advertiserName": "Nom de l'annonceur",
        "name": "Nom de la campagne",
        "iab": "Catégorie IAB"
      },
      "table": {
        "advertiser": {
          "parent": "Parent",
          "name": "Annonceur",
          "createdAt": "Date de création",
          "actions": "Actions"
        },
        "campaign": {
          "parent": "Parent",
          "advertiser": "Annonceur",
          "name": "Campagne",
          "advertiserDomainName": "Domaine",
          "createdAt": "Date de création",
          "actions": "Actions"
        },
        "parent": "Parent",
        "iab": "Catégorie IAB",
        "domain": "Domaine",
        "createdAt": "Date de création",
        "actions": "Actions"
      },
      "title": "Blacklists"
    }
  },
  "reseller": {
    "assistantRules": {
      "title": "Assistant",
      "table": {
        "key": "Cle",
        "type": "Type"
      },
      "fields": {
        "isActive": "Active",
        "importance": "Importance",
        "config": "Configuration",
        "configDescription": "Conditions a remplir pour que cette regle s'execute. Chaque ligne combine un scope, un champ, un operateur et une valeur. Le select logique impose que toutes les conditions soient vraies ou qu'au moins une le soit.",
        "recommendedChanges": "Changements recommandes",
        "recommendedChangesDescription": "Actions optionnelles proposees lorsque la regle correspond (par exemple mettre a jour un champ). Laissez vide si la regle doit seulement s'appuyer sur son titre et sa description, sans changements suggeres.",
        "entity": "Entite",
        "message": "Message",
        "key": "Cle",
        "value": "Valeur"
      },
      "modal": {
        "title": "Modifier la regle : {{name}}",
        "key": "Cle de regle : {{key}}",
        "createUserRuleTitle": "Creer une regle utilisateur",
        "editUserRule": "Modifier la regle utilisateur",
        "editSystemRule": "Modifier la regle systeme",
        "basicInfo": "Informations de base",
        "descriptionPlaceholder": "Decrivez ce que fait cette regle et quand elle doit se declencher"
      },
      "actions": {
        "createUserRule": "Creer une regle utilisateur"
      },
      "sections": {
        "systemRules": "Regles systeme",
        "userRules": "Regles utilisateur"
      },
      "errors": {
        "invalidJson": "La configuration doit etre un JSON valide.",
        "invalidRecommendedChangesJson": "Les changements recommandes doivent etre un tableau JSON valide.",
        "invalidJsonObject": "La configuration doit etre un objet JSON valide.",
        "missingRuleKey": "Cette regle ne peut pas etre modifiee car sa cle est manquante.",
        "noSchemaForRuleKey": "Aucun schema dedie trouve pour cette cle de regle systeme. Editeur JSON utilise.",
        "emptyConfig": "Aucune cle de configuration disponible pour cette regle.",
        "expectedString": "La valeur doit etre une chaine.",
        "expectedBoolean": "La valeur doit etre un booleen.",
        "deleteUserRule": "Echec de la suppression de la regle. Veuillez reessayer."
      },
      "configFields": {
        "adcopiesForBudget": "Creatives pour budget",
        "maxLifetimeDays": "Durée d'un A/B test",
        "weeklyClickThreshold": "Seuil de clic pour un A/B test",
        "minimumAdCopies": "Nombre minimum de creatives",
        "minimumBudgetPerAdCopy": "Budget minimum par creative",
        "maximumAdCopies": "Nombre maximum de creatives",
        "minimumImpressions": "Impressions minimum",
        "minimumDaysSinceLastAbTest": "Jours minimum depuis le dernier A/B test",
        "minimumAbTestImpressions": "Impressions minimum du A/B test",
        "maximumImbalanceRatio": "Ratio de desequilibre maximum",
        "minimumRemainingDays": "Jours restants minimum",
        "minimumDailyBudget": "Budget journalier minimum"
      },
      "systemRuleDescriptions": {
        "AdCopyMaxLifetimeExceeded": "Une ou plusieurs creatives ont atteint la duree de vie maximale.",
        "AdGroupNotEnoughAdCopiesForBudget": "L'adgroup n'a pas assez de creatives pour le budget actuel.",
        "AdGroupTooManyAdCopiesForBudget": "L'adgroup a trop de creatives pour le budget actuel.",
        "AdGroupAdCopyReadyForNewAbTest": "L'adgroup a une creative prete pour un nouveau A/B test.",
        "AdGroupImbalancedAbTestImpressions": "L'adgroup a des impressions A/B test desequilibrees.",
        "AdGroupIncreaseDailyBudgetForBudgetCapping": "Le capping budget journalier est trop bas. Augmentez le budget journalier ou passez en budget journalier automatique."
      },
      "systemRuleConfigKeys": {
        "AdGroupNotEnoughAdCopiesForBudget": {
          "adcopiesForBudget": "Creatives pour budget"
        }
      },
      "conditionEditor": {
        "logic": "Logique",
        "all": "Chaque regle doit etre valide",
        "any": "Une seule regle doit etre valide",
        "scope": "Portee",
        "field": "Champ",
        "operator": "Operateur",
        "action": "Action",
        "value": "Valeur",
        "params": "Paramètres",
        "addCondition": "Ajouter une condition",
        "compareField": "Champ à comparer",
        "compareFieldNeedsPrimary": "Sélectionnez d’abord un champ de condition",
        "compareFieldPrimaryUnavailable": "Ce champ ne peut pas servir à la comparaison",
        "compareToField": "Comparer à un champ",
        "compareToValue": "Comparer à une valeur"
      },
      "fieldTypeHints": {
        "currency": "Monnaie",
        "percent": "Pourcentage",
        "count": "Nombre d’éléments",
        "number": "Nombre",
        "boolean": "Booléen"
      },
      "paramsFields": {
        "periodDays": "Nombre de jours",
        "skipRecentDays": "Jours récents à ignorer"
      },
      "operators": {
        "Between": "Entre",
        "Contains": "Contient",
        "Eq": "Égal",
        "Falsy": "Est faux",
        "Gt": "Supérieur à",
        "Gte": "Supérieur ou égal à",
        "In": "Dans la liste",
        "Intersects": "Intersecte",
        "IsEmpty": "Est vide",
        "IsNotEmpty": "N'est pas vide",
        "Lt": "Inférieur à",
        "Lte": "Inférieur ou égal à",
        "Neq": "Différent de",
        "NotContains": "Ne contient pas",
        "Truthy": "Est vrai",
        "Delete": "Supprimer",
        "Replace": "Remplacer",
        "Update": "Mettre à jour"
      },
      "recommendedChangesEditor": {
        "group": "Logique",
        "all": "Chaque règle de changement recommandé doit être valide",
        "any": "Une seule règle de changement recommandé doit être valide",
        "messagePlaceholder": "Décrivez quoi changer lorsque cette règle est déclenchée (ex. : 'Augmenter le budget quotidien à 50€')",
        "messagePerConditionPlaceholder": "Message optionnel pour cette condition spécifique",
        "noChanges": "Aucun changement recommandé pour le moment. Ajoutez un groupe pour commencer.",
        "noActions": "Aucune action pour le moment. Cliquez sur « Ajouter une action » pour définir ce qui doit changer.",
        "addGroup": "Ajouter un groupe de recommandation",
        "conditions": "Conditions",
        "actionsDescription": "Ajoutez une ligne pour chaque paramètre concerné par cette recommandation.",
        "addAction": "Ajouter une action",
        "howToFixThat": "Pourquoi c'est nécessaire et comment le corriger ?",
        "doAllNecessary": "Faire tous les changements nécessaires",
        "onlyOneChange": "Un seul changement peut être effectué"
      },
      "scopes": {
        "adGroup": "AdGroup",
        "adCopies": "Créatives",
        "adGroupTargeting": "Ciblage AdGroup"
      },
      "scopeSubCategories": {
        "demographics": "Démographie",
        "geoTargeting": "Ciblage géographique",
        "deviceOs": "Appareil et OS",
        "timeTargeting": "Ciblage horaire",
        "reach": "Reach",
        "other": "Autre",
        "stats": "Statistiques"
      },
      "scopeFields": {
        "monthlyBudget": "Budget mensuel",
        "overallBudget": "Budget global",
        "startDate": "Date de début",
        "endDate": "Date de fin",
        "stats.averageDaySpent": "Moyenne de jours passés",
        "stats.yesterdayImpressions": "Impressions d'hier",
        "stats.yesterdayClicks": "Clics d'hier",
        "stats.yesterdayLeads": "Leads d'hier",
        "stats.yesterdayOrders": "Commandes d'hier",
        "stats.yesterdayCtr": "CTR d'hier",
        "stats.yesterdayLr": "LR d'hier",
        "stats.yesterdayOr": "OR d'hier",
        "stats.averageDailyImpressions": "Impressions moyennes quotidiennes",
        "stats.averageDailyClicks": "Clics moyens quotidiens",
        "stats.averageDailyLeads": "Leads moyens quotidiens",
        "stats.averageDailyOrders": "Commandes moyennes quotidiennes",
        "stats.averageDailyCtr": "CTR moyens quotidiens",
        "stats.averageDailyLr": "LR moyens quotidiens",
        "stats.averageDailyOr": "OR moyens quotidiens",
        "cpc": "CPC",
        "cpm": "CPM",
        "cpl": "CPL",
        "cpo": "CPO",
        "userCappingUncapped": "Capping utilisateur non limité",
        "userCappingImpression": "Capping utilisateur par impressions",
        "userCappingClick": "Capping utilisateur par clics",
        "status": "Statut",
        "dailyBudgetAuto": "Budget journalier automatique",
        "dailyBudgetFixed": "Budget journalier fixe",
        "dailyBudgetOpen": "Budget journalier ouvert",
        "budgetCappingType": "Type de plafonnement budgétaire",
        "dailyBudgetType": "Type de budget journalier",
        "device.type": "Type d'appareil",
        "os.exclusive": "OS exclusif",
        "os.type": "Type d'OS",
        "gender": "Genre",
        "age.range": "Tranche d'âge",
        "age.unknown": "Âge inconnu",
        "device.exclusive": "Appareil exclusif",
        "time.days": "Jours",
        "time.hours": "Heures",
        "geoTargeting.geoExclusive": "Ciblage géographique exclusif",
        "geoTargeting.countries": "Pays",
        "geoTargeting.geoTargetingType": "Type de ciblage géographique",
        "geoTargeting.cities": "Villes",
        "geoTargeting.regions": "Régions",
        "geoTargeting.departements": "Départements",
        "reach.impressions": "Impressions de reach",
        "reach.cpc": "Reach CPC",
        "count": "Nombre",
        "statuses": "Statuts",
        "titles": "Titres",
        "callToActions": "Call to actions"
      },
      "fieldUnits": {
        "Currency": "€",
        "Percent": "%",
        "Count": "#"
      },
      "scopeFieldDescriptions": {
        "monthlyBudget": "Montant maximal que le groupe peut dépenser par mois.",
        "overallBudget": "Plafond de budget total du groupe sur sa durée de vie.",
        "startDate": "Premier jour où le groupe peut diffuser.",
        "endDate": "Dernier jour où le groupe peut diffuser.",
        "stats.averageDaySpent": "Dépense journalière moyenne sur la période.",
        "stats.yesterdayImpressions": "Impressions enregistrées la veille.",
        "stats.yesterdayClicks": "Clics enregistrés la veille.",
        "stats.yesterdayLeads": "Leads enregistrés la veille.",
        "stats.yesterdayOrders": "Commandes enregistrées la veille.",
        "stats.yesterdayCtr": "Taux de clic la veille.",
        "stats.yesterdayLr": "Taux de lead la veille.",
        "stats.yesterdayOr": "Taux de commande la veille.",
        "stats.averageDailyImpressions": "Impressions moyennes par jour.",
        "stats.averageDailyClicks": "Clics moyens par jour.",
        "stats.averageDailyLeads": "Leads moyens par jour.",
        "stats.averageDailyOrders": "Commandes moyennes par jour.",
        "stats.averageDailyCtr": "Taux de clic moyen quotidien.",
        "stats.averageDailyLr": "Taux de lead moyen quotidien.",
        "stats.averageDailyOr": "Taux de commande moyen quotidien.",
        "cpc": "Coût par clic.",
        "cpm": "Coût pour mille impressions.",
        "cpl": "Coût par lead.",
        "cpo": "Coût par commande.",
        "userCappingUncapped": "Indique si le capping utilisateur est désactivé.",
        "userCappingImpression": "Fréquence max. utilisateur basée sur les impressions.",
        "userCappingClick": "Fréquence max. utilisateur basée sur les clics.",
        "status": "Statut de l'AdGroup.",
        "dailyBudgetAuto": "Budget journalier en mode automatique.",
        "dailyBudgetFixed": "Budget journalier fixe.",
        "dailyBudgetOpen": "Budget journalier en mode ouvert.",
        "budgetCappingType": "Mode de limitation des dépenses par rapport au budget.",
        "dailyBudgetType": "Stratégie du budget journalier.",
        "device.type": "Catégorie d’appareil ciblée.",
        "os.exclusive": "Ciblage exclusif sur une famille d’OS.",
        "os.type": "Famille de système d’exploitation ciblée.",
        "gender": "Ciblage démographique par genre.",
        "age.range": "Tranche d’âge ciblée.",
        "age.unknown": "Inclut ou non les utilisateurs d’âge inconnu.",
        "device.exclusive": "Ciblage exclusif sur un type d’appareil.",
        "time.days": "Jours de la semaine inclus dans le planning.",
        "time.hours": "Heures de la journée incluses dans le planning.",
        "geoTargeting.geoExclusive": "Ciblage géographique en mode exclusif ou non.",
        "geoTargeting.countries": "Pays inclus ou exclus du ciblage.",
        "geoTargeting.geoTargetingType": "Mode de ciblage géographique.",
        "geoTargeting.cities": "Villes incluses dans le ciblage.",
        "geoTargeting.regions": "Régions incluses dans le ciblage.",
        "geoTargeting.departements": "Départements inclus dans le ciblage.",
        "reach.impressions": "Impressions moyennes pour la population cible.",
        "reach.cpc": "CPC moyen pour la population cible.",
        "count": "Nombre de créatifs correspondant à la condition.",
        "statuses": "Statuts de créatif à faire correspondre.",
        "titles": "Titres de créatifs à faire correspondre.",
        "callToActions": "Libellés d’appel à l’action à faire correspondre."
      }
    }
  },
  "powerspace": {
    "account": {
      "title": "Accounting",
      "table": {
        "yesterdayCpm": "CPM d'hier",
        "lastModified": "Dernière modification",
        "remainingTime": "Temps restant",
        "budget": "Budget",
        "current": "Actuel",
        "spentToday": "Dépensé aujourd'hui",
        "recommendation": "Recommandation",
        "recommendationsCount_one": "1 recommandation",
        "recommendationsCount_other": "{{count}} recommandations",
        "recommendationsCount_many": "{{count}} recommandations"
      },
      "warning": {
        "dailyBudgetThreshold": "Le budget quotidien est supérieur à {{threshold}}€",
        "cpmThreshold": "Le CPM est inférieur au CPM moyen du reseller de {{resellerCPM}}€"
      }
    },
    "population": {
      "title": "Population atteinte"
    },
    "budgets": {
      "title": "Budgets quotidiens",
      "accountFilter": "Compte",
      "salesFilter": "Commercial",
      "dailyRepartition": "Budget quotidien",
      "revenueRepartition": "Revenus",
      "cpcRepartition": "CPC",
      "cpmRepartition": "CPM",
      "advertiserRepartition": "Annonceurs",
      "campaignRepartition": "Campagnes",
      "dayBudgetRatio": "{{ratio}}% du budget du jour",
      "spentOverDailyBudget": "{{spent}} dépensés sur {{budget}} de budget journalier"
    },
    "demandSources": {
      "title": "Sources de demande",
      "impressions": "Impressions",
      "unfilled": "Unfilled",
      "powerspace": "Powerspace",
      "other": "Autres"
    },
    "adProductTiers": {
      "category": "Catégorie",
      "adGroupsCount_one": "{{count}} ad group",
      "adGroupsCount_other": "{{count}} ad groups",
      "repartition": {
        "impressions": "Impressions",
        "clicks": "Clics",
        "costs": "Coûts"
      },
      "details": {
        "adGroups": "Groupes d'annonces",
        "ageGender": "Âge et genre",
        "age": "Par tranche d'âge",
        "gender": "Par genre",
        "ageRepartition": "Impressions par tranche d'âge",
        "genderRepartition": "Impressions par genre",
        "ageGenderUnavailable": "La répartition par âge et genre n'est disponible que pour les catégories complètes d'un tier.",
        "websites": "Sites",
        "iabCategories": "Catégories IAB",
        "otherCategories": "Autres catégories"
      },
      "adGroupsCount_many": "{{count}} ad groups"
    },
    "adGroups": {
      "title": "Analyse des AdGroups",
      "tabs": {
        "iabCategory": "Catégorie IAB",
        "iabContent": "Produit publicitaire IAB"
      },
      "iabRepartition": {
        "title": "Répartition des catégories IAB",
        "revenues": "Revenues par IAB",
        "otherDetails": "Autres",
        "minor": "Répartition des catégories IAB"
      },
      "top10AdGroups": "Top 10 ad groups",
      "iabTotalStats": "Statistiques de l'IAB",
      "globalCampaignStats": "Statistiques globales des campagnes",
      "globalIabRevenues": "Revenus globaux de l'IAB"
    },
    "validation": {
      "title": "Validation des créations",
      "empty": "Aucune création n'est en attente de validation."
    }
  },
  "sentEmail": {
    "verified": "Au moins un e-mail à cette adresse a été reçu",
    "lastEmailError": "Le dernier e-mail à cette adresse a échoué",
    "emailDoesNotExist": "L'adresse du destinataire n'existe pas",
    "statusPending": "En attente",
    "statusReceived": "Reçu",
    "statusError": "Erreur",
    "invoiceSectionTitle": "E-mails envoyés",
    "invoiceEmpty": "Aucun e-mail n'a encore été envoyé pour cette facture.",
    "subject": "Objet",
    "type": "Type",
    "sentAt": "Envoyé le",
    "types": {
      "Invoice": "Facture",
      "Invite": "Invitation",
      "ResetPassword": "Réinitialisation du mot de passe"
    }
  },
  "updated": "Mis à jour"
}
